/*
  LANGUAGE FILE FOR DANISH LANG
 */

export default {
    "€0.60/month for each additional learner over the prepaid amount":
        "€0,60/måned for hver studerende over det forudbetalte beløb",
    "€1.20/month for each additional learner over the prepaid amount":
        "€1,20/måned for hver studerende over det forudbetalte beløb",
    "2GB storage limit": "2GB lagerplads",
    "10GB storage limit": "10GB lagerplads",
    "30GB storage limit": "30GB lagerplads",
    "3-digit code placed on the back side of the card, in the signature area":
        "3-cifret kode placeret på bagsiden af dit kort, ved signaturen.",
    Abandon: "Afbryd",
    "Abandon copying to this group": "Afbryd kopiering til dette hold",
    "Account already linked": "Konto eksisterer allerede i systemet",
    "Accept terms": "Accepter betingelser",
    "Account linked": "Konto linket",
    "Access denied!": "Adgang nægtet!",
    "Account succesfully linked with": "Konto succesfuldt linket med",
    "Account type": "Kontotype",
    Actions: "Muligheder",
    Active: "Aktiv",
    "Active learners": "Aktive studerende",
    "Active learners above the plan in this month":
        "Aktive studerende mere end betalt for denne måned",
    "Active learners in this month": "Aktive studerende i denne måned",
    "Active learners on plan": "Aktive studerende på plan",
    Activity: "Aktivitet",
    Activities: "Aktiviteter",
    "Activities, quizzes & assignments": "Aktiviteter, quizzer og opgaver",
    "Adaptive settings": "Adaptive indstillinger",
    "Adaptive test": "Adaptiv test",
    "Adaptive tests": "Adaptive tests",
    Add: "Tilføj",
    "Additional group": "Sekundært hold",
    "Add a document": "Tilføj et dokument",
    "Add a file": "Tilføj fil",
    "Add a new learner or co-teacher": "Tilføj ny elev eller med-underviser",
    "Add activities": "Tilføj aktiviteter",
    "Add additional group": "Tilføj sekundært hold",
    "Add answer": "Tilføj svar",
    "Add assignment": "Tilføj opgave",
    "Add attachment": "Tilføj fil",
    "Add audio": "Tilføj lyd",
    "Add board": "Tilføj opslagstavle",
    "Add board item": "Tilføj opslag",
    "Add category": "Tilføj Kategori",
    "Add collection": "Tilføj kollektion",
    "Add conversation name": "Tilføj navn på samtale",
    "Add course": "Tilføj forløb",
    "Add dashboard widget": "Tilføj dashboard widget",
    "Add description": "Tilføj beskrivelse",
    "Add discussion topic": "Tilføj debatemne",
    "Add event": "Tilføj event",
    "Add existing activities": "Tilføj eksisterende aktivitet",
    "Add existing material": "Tilføj eksisterende lektion",
    "Add expression": "Tilføj udtryk",
    "Add external link": "Tilføj eksternt link",
    "Add extra item": "Tilføj ekstra element",
    "Add feedback": "Tilføj feedback",
    "Add file": "Tilføj fil",
    "Add files/folders": "Tilføj filer/mapper",
    "Add first learning element to this course":
        "Tilføj din første læringsaktivitet til dette hold",
    "Add flashcard": "Tilføj flashkort",
    "Add folder": "Tilføj mappe",
    "Add geogebra": "Tilføj Geogebra",
    "Add image": "Tilføj billede",
    "Add information": "Tilføj information",
    "Add item": "Tilføj element",
    "Add label": "Tilføj etiket",
    "Add labels to the image": "Tilføj etiketter til billedet",
    "Add learning activities": "Tilføj læringsaktiviteter",
    "Add learning activity": "Tilføj læringsaktivitet",
    "Add lesson": "Tilføj lektion",
    "Add lessons to your course": "Tilføj lektioner til dit forløb",
    "Add image label": "Tilføj billedetikette",
    "Add match": "Tilføj match",
    "Add match set": "Tilføj match sæt",
    "Add material": "Tilføj lektion",
    "Add member": "Tilføj medlem",
    "Add members": "Tilføj medlemmer",
    "Add members manually to the class below":
        "Tilføj manuelt medlemmer til dette hold nedenfor",
    "Add members to this class": "Tilføj medlemmer til dette hold",
    "Add teachers to your plan": "Tilføj undervisere til dit abonnement",
    "Add participants": "Tilføj medlemmer",
    "Add new course": "Tilføj nyt forløb",
    "Add new dependency": "Tilføj ny forudsætning",
    "Add new flashcard": "Tilføj nyt flashkort",
    "Add new institution": "Tilføj ny institution",
    "Add new item": "Tilføj ny aktivitet",
    "Add new learning element": "Tilføj ny læringsaktivitet",
    "Add new match option": "Tilføj ny match mulighed",
    "Add new material": "Tilføj ny lektion",
    "Add new question": "Tilføj nyt spørgsmål",
    "Add new tag": "Tilføj nyt emne",
    "Add news": "Tilføj nyhed",
    "Add numeric variable": "Tilføj en numerisk variabel",
    "Add only tags that do not exist yet. Make sure you have tried to search for the tag before adding.":
        "Tilføj venligst kun emner som endnu ikke eksisterer i systemet. Sørg for at prøve at søge grundigt før du tilføjer.",
    "Add question": "Tilføj spørgsmål",
    "Add questions": "Tilføj spørgsmål",
    "Add questionnaire": "Tilføj spørgeskema",
    "Add quiz": "Tilføj quiz",
    "Add one learning element at a time. Save changes in order to continue creating.":
        "Tilføj én læringsaktivitet af gangen. Gem ændringerne for at forsætte med at bygge.",
    "Add submission example": "Tilføj afleveringseksempel",
    "Add text": "Tilføj tekst",
    "Add text label": "Tilføj tekstetikette",
    "Add timeline": "Tilføj tidslinje",
    "Add to existing activity": "Tilføj til eksisterende aktivitet",
    "Add to word list": "Tilføj til ordliste",
    "Add video": "Tilføj video",
    "Add Vimeo video": "Tilføj Vimeo video",
    "Add youtube video": "Tilføj youtube video",
    "Add your first document that will be shared with your class":
        "Tilføj din første fil til fildelingen med holdet",
    Added: "Tilføjet",
    "Add groups": "Tilføj hold",
    "Add new answer possibility": "Tilføj ny svarmulighed",
    "Add new element": "Tilføj ny aktivitet",
    "Add new expression": "Tilføj nyt udtryk",
    "Add new nummeric variable": "Tilføj ny nummerisk variabel",
    "Add title": "Tilføj titel",
    "Add vacation/holiday": "Tilføj ferie/helligdag",
    "Add word": "Tilføj ord",
    "Add words to the word list. Any number of words from the list can be chosen at random.":
        "Tilføj ord til ordlisten. Ethvert ord fra listen kan blive tilfældigt udvalgt.",
    "Adjust your settings and start a call":
        "Tilpas dine indstillinger og start opkaldet",
    Admin: "Underviser",
    Admins: "Undervisere",
    Administration: "Administration",
    "Advanced integrations": "Udvidede integrationer",
    "Advanced settings": "Udvidede indstillinger",
    Afrikaans: "Afrikaans",
    Albanian: "Albansk",
    All: "Alle",
    "All changes were saved": "Alle ændringer blev gemt",
    "All classes, courses and content will be transferred, and nothing will be lost.":
        "Alle hold, forløb og indhold vil blive overført, og intet vil gå tabt.",
    "All communication suspended.": "Al kommunikation er suspenderet.",
    "All correct answers must be chosen": "Alle korrekte svar skal vælges",
    "All correct answers must be selected": "Alle korrekte svar skal vælges",
    "All file types": "Alle filtyper",
    "All topics": "Alle delemner",
    "All variables must have one hashtag in the beginning and lower threshhold must be lower than the upper threshhold":
        "Alle variable skal have et hashtag i begyndelsen og den nedre værdi må ikke være højere end den øvre.",
    "Allow counsellors": "Tillad vejledere",
    "Enable the Olly AI assistant for students": "Aktivér AI-assistenten Olly for elever",
    "When off, the Olly assistant is hidden for students. Olly is also hidden automatically while a class is in exam mode.": "Når den er slået fra, skjules Olly-assistenten for elever. Olly skjules også automatisk, mens et hold er i eksamenstilstand.",
    "Enable the Olly AI assistant for teachers": "Aktivér AI-assistenten Olly for lærere",
    "When off, the Olly assistant is hidden for teachers.": "Når den er slået fra, skjules Olly-assistenten for lærere.",
    "Allow repeating single questions": "Tillad gentagelse af enkelte spørgsmål",
    "Allow direct user creation in the group":
        "Tillad direkte brugeroprettelse på holdet",
    "Allow groups": "Tillad gruppeaflevering",
    "Allow code join": 'Slå "tilmed medlemmer med kode" til',
    "Allow late submission": "Tillad aflevering efter frist",
    "Block late submission for this student": "Luk for aflevering efter frist for denne kursist",
    "Allow late submission for this student": "Tillad aflevering efter frist for denne kursist",
    "Late submission is closed for this student": "Aflevering efter frist er lukket for denne kursist",
    "Late submission is open for this student": "Aflevering efter frist er åben for denne kursist",
    "Something went wrong": "Noget gik galt",
    "Allow late turnin": "Tillad aflevering efter frist",
    "Allow questions on material elements":
        "Tillad spørgsmål på læringsaktiviteter",
    "Allow groups code join": "Tillad holdtilmelding med link",
    "Hide 'continue where you left off' on dashboard":
        "Skjul 'Fortsæt hvor du kom fra' på forsiden",
    "All participants from your class can access this call. If you want to invite others, send them a link.":
        "Alle medlemmer af dit hold kan tilgå dette opkald. Hvis du vil have andre ind, så send dem linket til opkaldet.",
    "Allow peers": "Tillad at se andres afleveringer",
    "Allow students to see results": "Tillad studerende at se resultater",
    "Allowed file types": "Tilladte filtyper",
    "Already a user?": "Allerede en bruger?",
    "Already have an account?": "Har du allerede en bruger?",
    Amount: "Beløb",
    "An error occurred": "Det opstod en fejl",
    "An error occurred in the quiz. Please refresh your browser window, and if the error persists, contact the support.":
        "Der opstod en fejl med at hente quizzen. Venligst genindlæs browservinduet, og hvis fejlen fortsætter så kontakt supporten.",
    "Ancient history": "Oldtidskundskab",
    Answer: "Svar",
    "Answer's feedback": "Svarets feedback",
    "Answer date": "Svar dato",
    "Answer {number} more": "Svar på {number} mere",
    "Answer evaluation criteria": "Evalueringskriterie på svar",
    "Answer possibilities": "Svarmuligheder",
    "Answer possibility": "Svarmulighed",
    "Answer the question to continue the video":
        "Svar på spørgsmålet for at fortsætte videoen",
    Answers: "Svar",
    "Answers must have a unique match option assigned":
        "Alle svarmuligheder skal have en unik match-mulighed tilknyttet",
    "Answers not in category": "Svar uden for kategori",
    "Answers will be shown after quiz is completed":
        "Svarene vil blive vist, når quizzen er afsluttet",
    "Appears on": "Optræder på",
    Apps: "Apps",
    Arabic: "Arabisk",
    Archive: "Arkivér",
    "Archive class": "Arkivér hold",
    "Archive class for all members": "Arkivér holdet for alle medlemmer",
    "Archive for all": "Arkivér for alle",
    "Archive for you": "Arkivér for kun dig",
    Archived: "Arkiveret",
    "Archived Group Exclusions": "Ekskluderinger af Arkiverede Hold",
    "Archived groups": "Arkiverede hold",
    "Active news": "Aktive nyheder",
    Inactive: "Inaktiv",
    Activate: "Aktiver",
    Deactivate: "Deaktiver",
    "News archive": "Arkiv",
    "News activated": "Nyhed aktiveret",
    "News deactivated": "Nyhed deaktiveret",
    "Add to Exclusion List": "Tilføj til eksklusionsliste",
    "Are you a student or a teacher?": "Er du studerende eller en underviser?",
    "Are you sure you want to remove this group from the exclusion list?": "Er du sikker på, at du vil fjerne dette hold fra eksklusionslisten?",
    "Are you sure?": "Er du sikker?",
    "Are you sure you have checked the list thoroughly? Remember you can search it too!":
        "Er du sikker på du har tjekket listen ordentligt igennem? Husk du også kan søge i den!",
    "Are you sure you want to archive this conversation?":
        "Er du sikker på du vil arkivere denne samtale?",
    "Are you sure you want to archive this group?":
        "Er du sikker på du vil arkivere dette hold?",
    "Are you sure you want to archive this group for all members?":
        "Er du sikker på du vil arkivere dette hold for alle medlemmer?",
    "Are you sure you want to delete this?":
        "Er du sikker på du vil slette dette?",
    "Are you sure you want to delete this assignment?":
        "Er du sikker på du vil slette denne opgave?",
    "Are you sure you want to delete this collection?":
        "Er du sikker på du vil slette denne kollektion?",
    "Are you sure you want to delete this feedback?":
        "Er du sikker på du vil slette dette feedback?",
    "Are you sure you want to delete this file?":
        "Er du sikker på du vil slette denne fil?",
    "Are you sure you want to delete this folder?":
        "Er du sikker på du vil slette denne mappe? Dette fjerner også alle undermapper og filer.",
    "Are you sure you want to delete this Geogebra element?":
        "Er du sikker på du vil slette denne Geogebra aktivitet?",
    "Are you sure you want to delete this group?":
        "Er du sikker på du vil slette dette hold?",
    "Are you sure you want to delete this group information?":
        "Er du sikker på du vil fjerne denne information?",
    "Are you sure you want to delete this post?":
        "Er du sikker på du vil slette dette opslag?",
    "Are you sure you want to delete this question?":
        "Er du sikker på du vil slette dette spørgsmål?",
    "Are you sure you want to delete this quiz?":
        "Er du sikker på du vil slette denne quiz?",
    "Are you sure you want to delete this user?":
        "Er du sikker på du vil slette denne bruger?",
    "Are you sure you want to delete this widget?":
        "Er du sikker på du vil slette denne widget?",
    "Are you sure you want to discard this learning activity?":
        "Er du sikker på, at du ønsker at kassere denne læringsaktivitet?",
    "Are you sure you want to leave the meeting?":
        "Er du sikker på du vil forlade mødet?",
    "Are you sure you want to mark student as a self-study? This will move all assignments years into the future.":
        "Er du sikker på du vil markere denne studerende som selvstuderende? Dette vil flytte alle afleveringerne mange år frem i tiden.",
    "Are you sure you want to open learner view without saving the changes?":
        "Er du sikker på du vil skifte til brugervisning, uden at gemme dine ændringer?",
    "Are you sure you want to recalculate assignment plan?":
        "Er du sikker på du vil genberegne opgaveplanen?",
    "Are you sure you want register maternity leave for":
        "Are you sure you want register maternity leave for",
    "Are you sure you want to remove from your plan?":
        "Er du sikker på du vil fjerne {insertion} fra din plan?" /* Translate with param */,
    "Are you sure you want to remove this answer?":
        "Er du sikker på du vil fjerne dette svar?",
    "Are you sure you want to remove this course?":
        "Er du sikker på du vil fjerne dette forløb?",
    "Are you sure you want to remove this label?":
        "Er du sikker på du vil fjerne denne etikette?",
    "Are you sure you want to remove this learning element?":
        "Er du sikker på du vil fjerne denne læringsaktivitet?",
    "Are you sure you want to remove this lesson?":
        "Er du sikker på du vil fjerne denne lektion?",
    "Are you sure you want to remove this member?":
        "Er du sikker på du vil fjerne dette medlem?",
    "Are you sure you want to remove this match set?":
        "Er du sikker på du vil fjerne dette match sæt?",
    "Are you sure you want to remove this material?":
        "Er du sikker på du vil fjerne denne lektion?",
    "Are you sure you want to remove this question?":
        "Er du sikker på du vil fjerne dette spørgsmål?",
    "Are you sure you want to remove this subject?":
        "Er du sikker på du vil fjerne dette emne?",
    "Are you sure you want to remove this topic?":
        "Er du sikker på du vil fjerne dette underemne?",
    "Are you sure you want to remove this variable?":
        "Er du sikker på du vil fjerne denne variabel?",
    "Are you sure you want to remove this user?":
        "Er du sikker på du vil fjerne denne bruger?",
    "Are you sure you want to remove this widget?":
        "Er du sikker på du vil fjerne denne widget?",
    "Are you sure you want to remove this word?":
        "Er du sikker på du vil fjerne dette ord?",
    "Are you sure you want to start a video call?":
        "Er du sikker på du gerne vil starte et videokald?",
    "Are you sure you want to start a video call with this user?":
        "Er du sikker på du vil starte et video kald med denne bruger?",
    "Are you sure you want to submit this questionnaire?":
        "Er du sikker på du vil aflevere dette spørgeskema?",
    "Are you sure you want to turn in this quiz?":
        "Er du sikker på du vil aflevere denne quiz?",
    "Are you sure you want to unarchive this group?":
        "Er du sikker på du vil fjerne dette hold fra arkiveret?",
    "Are you sure you want to unlink your account from":
        "Er du sikker på du vil frakoble din konto fra",
    "Are you sure you want to unsubscribe?":
        "Er du sikker på du vil opsige dit abonnement?",
    "Are you unsure? Click the button below to read a guide on this":
        "Er du usikker? Klik på knappen nedenfor, for at læse en guide om emnet.",
    Armenian: "Armensk",
    Arrows: "Pile",
    "As a teacher, you are automatically always in training mode, and we will not store your answers, but you can test the quiz.":
        "Som underviser er du automatisk i træning på quizzen. Det betyder at vi ikke gemmer dine svar så du kan teste den.",
    "Ask to join": "Anmod om adgang",
    "Ask your students to go to": "Bed dine studerende om at gå til",
    Assessments: "Bedømmelser",
    Assign: "Tildel",
    "Assign category": "Tildel kategori",
    "Assign learners to counsellors": "Fordel brugere til vejledere",
    "Assign student": "Tildel studerende",
    "Assign student to": "Tildel studerende til",
    "Assign task to Olly": "Tildel opgave til Olly",
    Assignment: "Aflevering",
    assignment_objects: "Aflevering",
    assignments: "Afleveringer",
    "Assignments behind": "Afleveringer bagud",
    "Assignments completion percentage": "Aflevering fuldførelsesprocent",
    "Assignment answer": "Afleveret opgave",
    "Assignment created": "Aflevering oprettet",
    "Assignment handin timeline": "Tidslinje for opgaveaflevering",
    "Assignment handins/feedback statistics":
        "Opgaveafleverings/feedback statistik",
    "Assignment plans": "Afleveringsplaner",
    "Assignment rejected": "Aflevering afvist",
    "Assignment removed": "Aflevering fjernet",
    "Assignment saved": "Aflevering gemt",
    "Assignment statistics": "Afleveringsstatistik",
    "Assignment text": "Afleveringstekst",
    "Assignment title": "Afleveringstitel",
    "Assignment turnins missing feedback": "Afleveringer uden feedback",
    "Assignment turnin overview": "Opgaveafleveringsoverblik",
    "At least one correct answer chosen":
        "Mindst ét af de korrekte svar er valgt",
    "Attach media": "Vedhæft fil",
    "Attach to feedback": "Gem på feedback",
    Attachments: "Vedhæftede filer",
    Attachment: "Vedhæftet fil",
    "Attachment required": "Vedhæftning påkrævet",
    "This file type is not allowed here": "Denne filtype er ikke tilladt her",
    "The file is empty (0 bytes) and cannot be uploaded. Save or export it again, then try again. If it is in OneDrive or iCloud, download it to your computer first.":
        "Filen er tom (0 bytes) og kan ikke uploades. Gem eller eksportér den igen, og prøv så igen. Ligger den i OneDrive eller iCloud, så hent den ned på computeren først.",
    "This assignment only accepts PDF files.": "Denne aflevering modtager kun PDF-filer.",
    "This assignment only accepts video files.": "Denne aflevering modtager kun videofiler.",
    "This assignment only accepts PDF files. Please convert your file to PDF and try again.": "Denne aflevering modtager kun PDF-filer. Konvertér din fil til PDF og prøv igen.",
    Attempt: "Forsøg",
    "Average on teams": "Gennemsnit på hold",
    "Average quiz answer percentage for group":
        "Gennemsnitlig svarprocent for quizzer på holdet",
    "Average user completion": "Gennemsnitlig brugerfuldførelse",
    Audio: "Lyd",
    "Audio is on": "Lyd tændt",
    Australian: "Australsk",
    "Awaiting feedback": "Afventer feedback",
    Back: "Tilbage",
    "Back to all news": "Tilbage til alle nyheder",
    "Back to courses": "Tilbage til forløb",
    "Back to course overview": "Tilbage til forløbsoverblik",
    "Back to dashboard": "Tilbage til dashboard",
    "Back to debate list": "Tilbage til debatlisten",
    "Back to groups": "Tilbage til hold",
    "Back to information list": "Tilbage til informationsliste",
    "Back to lessons overview": "Tilbage til lektionsoversigten",
    "Back to overview": "Tilbage til oversigt",
    "Back to the dashboard": "Tilbage til overblikket",
    "Back to quizzes": "Tilbage til quizzer",
    Basic: "Basic",
    "Basic & advanced integrations": "Basis & advancerede integrationer",
    "Basic integrations": "Basis integrationer",
    "Below are download links to the most popular browsers, in case you do not have them installed":
        "Nedenfor er links til de mest populære browsere, i tilfælde af at du ikke har dem installeret endnu.",
    Billing: "Abonnement",
    "Billing history": "Faktureringshistorik",
    Biology: "Biologi",
    Black: "Sort",
    Blue: "Blå",
    Board: "Opslagstavle",
    Bosnian: "Bosnisk",
    "Brazilian Portuguese": "Portugisisk (Brazilien)",
    "Build structured blocks of text to inform your students on exams procedures, tell them about yourself, or add a course description.":
        "Byg strukturerende blokke af tekster for at informere dine brugere om eksamensprocedurer, fortæl om dig selv eller tilføj en indholdsbeskrivelse.",
    "Business economics": "Erhvervsøkonomi",
    "By closing this modal you discard all learning activities prepared by Olly":
        "Hvis du lukker dette vindue, kasserer du alle læringsaktiviteter, der er forberedt af Olly",
    "By creating an account I accept Terms and Conditions and Edaptio's default Notification settings":
        "Ved at oprette en bruger accepterer jeg {termsLink} og Edaptio's generelle {notifLink}" /* Translate with params like in en_Us */,
    "By deleting the last element you discard the whole learning activity":
        "Ved at slette det sidste {name} sletter du hele læringsaktiviteten" /* Translate with param */,
    "By signing up you accept our": "Ved at oprette dig, accepterer du vores",
    "By unsubscribing you will continue to have plan access and be charged monthly for active learners above count until date. After this period you will only be able to keep 2GB of storage and 15 active learners.":
        "Ved at afmelde dig vil du fortsat have {plan}-adgang og blive opkrævet månedligt for aktive elever over {learners} indtil {validUntil}. Efter denne periode vil du kun beholde 2 GB lagerplads og max 15 aktive elever." /* Translate with params */,
    "By unsubscribing you will be downgraded to Basic Plan at the end of this billing cycle. After this period you will only be able to keep 2GB of storage and 15 active learners.":
        "Ved at afmelde dig vil du blive nedgraderet til Basic planen i slutningen af denne faktureringscyklus. Efter denne periode vil du kun kunne beholde 2 GB lagerplads og 15 aktive elever.",
    Ca: "Ca",
    Calculate: "Beregn",
    "Calculate this expression": "Udregn dette udtryk",
    Camera: "Kamera",
    "Camera not available. You can still join with audio.": "Kamera ikke tilgængeligt. Du kan stadig deltage med lyd.",
    "Camera off": "Kamera af",
    "Camera on": "Kamera på",
    Cancel: "Annuller",
    "Cancel call": "Afbryd opkald",
    "Case sensitive": "Skal skelne imellem store og små bogstaver",
    "Card details": "Kortoplysninger",
    "Card number": "Kortnummer",
    "Cardholder name": "Navn på kort",
    Catalan: "Katalansk",
    Categories: "Kategorier",
    Category: "Kategori",
    "Category items": "Kategori elementer",
    "changed the feedback for the assignment":
        "ændrede sit feedback til afleveringen",
    Changelog: "Changelog",
    "Change card": "Skift kort",
    "Change group": "Udskift hold",
    "Change image": "Udskift billede",
    "Change institution": "Skift institution",
    "Change moodle relation": "Skift moodle relation",
    "Change password": "Skift kodeord",
    "Change payment method": "Skift betalingsmetode",
    "Change plan": "Skift plan",
    "Change plan selection": "Skift planvalg",
    "Change UMS relation": "Skift UMS relation",
    characters: "tegn",
    chat: "Chat",
    Chat: "Chat",
    Checkbox: "Afkrydsningsfelt",
    "Check schedule of a specific class or class member":
        "Se skema for et specifit hold eller medlem",
    "Check your inbox!": "Tjek din indbakke!",
    Chemestry: "Kemi",
    "Change submission date for user":
        "Giv brugeren en ny afleveringsdato for denne opgave",
    Chinese: "Kinesisk",
    "Co-creation": "Samskabelse",
    "Connect Facebook": "Forbind Facebook",
    "Connect Microsoft": "Forbind Microsoft",
    "Connect Google": "Forbind Google",
    "Connect your account": "Forbind din bruger",
    Choose: "Vælg",
    "Choose another element": "Vælg en anden aktivitet",
    "Choose another group": "Vælg et andet hold",
    "Choose assignment": "Vælg opgave",
    "Choose assignment from group": "Vælg opgave fra hold",
    "Choose between seeing quizzes the user has passed or completed.":
        "Vælg imellem at se quizzer som en bruger har bestået eller fuldført.",
    "Choose class": "Vælg fag",
    "Choose collection": "Vælg kollektion",
    "Choose collection from group": "Vælg kollektion fra hold",
    "Choose column representation": "Vælg kolonne repræsentation",
    "Choose correct match option": "Vælg den korrekte match mulighed",
    "Choose course": "Vælg forløb",
    "Choose CSV file": "Vælg CSV fil",
    "Choose date": "Vælg dato",
    "Choose element": "Vælg aktivitet",
    "Choose element type": "Vælg aktivitets type",
    "Choose from filesharing": "Vælg fra fildeling",
    "Choose files": "Vælg filer",
    "Choose from existing materials": "Vælg fra eksisterende lektioner",
    "Choose gender": "Vælg køn",
    "Choose Geogebra": "Vælg Geogebra",
    "Choose Geogebra from group": "Vælg Geogebra fra hold",
    "Choose grade": "Vælg karakter",
    "Choose group": "Vælg hold",
    "Choose institution": "Vælg institution",
    "Choose material": "Vælg lektion",
    "Choose members": "Vælg medlemmer",
    "Choose language": "Vælg sprog",
    "Choose learning element": "Vælg læringsaktivitet",
    "Choose lesson": "Vælg lektion",
    "Choose new file": "Vælg ny fil",
    "Choose questionnaire": "Vælg spørgeskema",
    "Choose questionnaire from group": "Vælg spørgeskema fra hold",
    "Choose quiz": "Vælg quiz",
    "Choose quiz from group": "Vælg quiz fra hold",
    "Choose random words": "Vælg tilfældige ord",
    "Choose subgroup": "Vælg underhold",
    "Choose time": "Vælg tid",
    "Choose the default language of the group":
        "Vælg standard sprog dette hold undervises i (bruges til at læse op)",
    "Choose the strategy with which Olly should create activity":
        "Vælg den strategi, som Olly skal lave {name} med" /* Translate with param */,
    "Choose type": "Vælg type",
    "Choose user": "Vælg bruger",
    "Choose weekday": "Vælg ugeday",
    "Choose what this group is teaching": "Vælg hvad dette hold underviser i",
    Chosen: "Valgt",
    "Chosen file": "Valgt fil",
    "Chosen group": "Valgt hold",
    "Chosen monthly plan summary":
        "Du opgraderer til {name} Plan. Planen fornyes automatisk hver måned, indtil den annulleres." /* Translate with params */,
    "Chosen user": "Valgt bruger",
    "Chosen yearly plan summary":
        "Du opgraderer til 1 års {name}-adgang og sparer 25 % ved at foretage en engangsbetaling. Planen fornyes automatisk årligt, indtil den annulleres." /* Translate with params */,
    class: "hold",
    Class: "Hold",
    "Class admins": "Undervisere",
    "Class code": "Holdkode",
    "class dashboard": "Holdside",
    "Class tracking & insights": "Holdstatistikker og indsigter",
    Classes: "Hold",
    Classic: "Klassisk",
    "Class members": "Medlemmer",
    "Class notebook link": "Link til klassenotesbog",
    "Class not found": "Hold ikke fundet",
    "Class subject": "Holdets fag",
    Clear: "Ryd",
    "Click enter to submit": "Klik enter for at tilføje",
    "Click here to add a new learning element or edit the selected element":
        "Klik her for at tilføje nye læringsaktiviteter eller redigere i den valgte aktivitet",
    "Click here to add existing material, create a new material or change the current material order":
        "Klik her for at tilføje eksisterende lektioner, oprette en ny lektion eller ændre rækkefølgen på de eksisterende lektioner",
    "Click here to create a new assignment":
        "Klik her for at oprette en ny opgave",
    "Click here to create a new conference post":
        "Klik her for at oprette en ny tråd eller et nyt spørgsmål",
    "Click here to create a new conversation with a student or a group":
        "Klik her for at oprette en ny samtale med en bruger eller et hold",
    "Click here to create a new course or change the current course order":
        "Klik her for at oprette et nyt forløb, eller ændre rækkefølgen på de eksisterende forløb",
    "Click here to create a new Geogebra element":
        "Klik her for at oprette et ny Geogebra aktivitet",
    "Click here to create a new material":
        "Klik her for at oprette en ny lektion",
    "Click here to create a new news post":
        "Klik her for at oprette en ny nyhed på holdet",
    "Click here to create a new quiz": "Klik her for at oprette en ny quiz",
    "Click here to create a new question":
        "Klik her for at oprette et nyt spørgsmål",
    "Click here to edit the group information text":
        "Klik her for at redigere gruppe informationsteksten",
    "Click here to go to your class notebook":
        "Klik her for at gå til din klassenotesbog",
    "Click left/right arrows to go to next/previous card":
        "Klik på venstre/højre pilene for at gå til næste/forrige kort",
    "Click on the link to activate your account. Don’t see it? Check your spam folder too :)":
        "Klik på linket for at aktivere din konto. Kan du ikke se det? Tjek også din spam-mappe :)",
    "Click on the answer to the left, and then a match option to the right, in order to make a connection.":
        "Klik på svaret til venstre, og derefter matchmuligheden til højre, for at oprette en forbindelse.",
    "Click on the card to see the back": "Klik på kortet for at se bagsiden",
    "Click on the card to see the front": "Klik på kortet for at se forsiden",
    "Click the add learning element button in the menu on the left":
        "Klik på tilføj læringsaktivitet i menuen i venstre side",
    "Click the create button to get started":
        "Klik på opret knappen for at komme igang",
    "Click the big button in the lower right corner to get started":
        "Klik på den store knap i nedre højre hjørne for at komme igang",
    "Click the button above to begin":
        "Klik på knappen ovenfor, for at begynde",
    "Click the button to add the first learning element":
        "Klik på knappen for at tilføje den første læringsaktivitet",
    "Click the create button on the left side to get started":
        "Klik på opret knappen i venstre side for at komme igang",
    "Click this button and click one of the sub-buttons to create a new folder or upload a new file":
        "Klik denne knap, og så klik en af de mindre knapper for at oprette en ny mappe eller tilføje en ny fil.",
    "Click this button to open the menu with your groups on all pages":
        "Klik på knappen for at åbne menuen med alle dine hold på alle sider",
    "Click to start edit": "Klik for at redigere",
    "Click up/down arrows to flip card":
        "Klik på op/ned pilene for at flippe kortet",
    Close: "Luk",
    "Close modal and create": "Luk vindue og opret",
    cloze: "Fill in the blank (Cloze)",
    code: "kode",
    Collapse: "Fold sammen",
    Color: "Farve",
    "Color can't be empty.": "Farve kan ikke være tom.",
    Comment: "Kommentar",
    "Comment created": "Kommentar oprettet",
    "Comment on news": "Kommentér på nyheder",
    "Comment removed": "Kommentar fjernet",
    Comments: "Kommentarer",
    Company: "Firma",
    "Compare plans": "Sammenlign planer",
    Completed: "Fuldført",
    "Completed consultations": "Afholdte konsultationer",
    "Completion advisor": "Gennemførselsvejleder",
    Confirm: "Bekræft",
    "Contact support": "Kontakt support",
    "Contact support@edaptio.com for more info":
        "Kontakt support@edaptio.com for mere info",
    "Contact us": "Kontakt os",
    Content: "Indhold",
    Continue: "Fortsæt",
    "Continue where you left off": "Fortsæt hvor du kom fra",
    conference: "Forum",
    "Conference thread": "Forumtråd",
    "Consultation created": "Konsultation oprettet",
    "Consultation deleted": "Konsultation slettet",
    "Consultation updated": "Konsultation opdateret",
    consultations: "Konsultationer",
    Consultations: "Konsultationer",
    Conversations: "Samtaler",
    "Conversation creation": "Opret samtale",
    "Conversation name": "Samtalenavn",
    "Conversation members": "Medlemmer af samtalen",
    "Collapse all": "Fold alle sammen",
    Collection: "Kollektion",
    Collections: "Kollektioner",
    "Complete registration": "Fuldfør registrering",
    Copied: "Kopieret",
    "Copied to clipboard": "Kopieret til udklipsholder",
    Copy: "Kopier",
    "Copy/paste your text source here. Olly will use this as context for generating content":
        "Kopier/indsæt din tekstkilde her. Olly vil bruge dette som kontekst til at generere indhold",
    "Copy activity": "Kopier læringsaktivitet",
    "Copy answer to the feedback field": "Kopier svar til feedback felt",
    "Copy class": "Kopier hold",
    "Copy course": "Kopier forløb",
    "Copy course and bypass sync": "Kopier forløb og synkronisér ikke",
    "Copy course and sync": "Kopier forløb og synkronisér",
    "Copy element": "Kopier aktivitet",
    "Copy element and bypass sync": "Kopier aktivitet og synkronisér ikke",
    "Copy element and sync": "Kopier aktivitet og synkronisér",
    "Copy element to other group": "Kopier aktivitet til et andet hold",
    "Copy element to these groups?": "Kopier aktivitet til disse hold?",
    "Copy element to this group?": "Kopier aktivitet til dette hold",
    "Copy existing question": "Kopier eksisterende spørgsmål",
    "Copy file": "Kopier fil",
    "Copy file url to clipboard": "Kopier filens webadresse til udklipsholder",
    "Copy group": "Kopier hold",
    "Copy groups": "Kopier hold",
    "Copy here": "Kopier hertil",
    "Copy lesson": "Kopier lektion",
    "Copy lesson and bypass sync": "Kopier lektion og synkronisér ikke",
    "Copy lesson and sync": "Kopier lektion og synkronisér",
    "Copy link": "Kopier link",
    "Copy new adaptive test": "Kopier new adaptiv test",
    "Copy of": "Kopi af",
    "Copy submission": "Kopier opgave",
    "Copy to clipboard": "Kopier til udklipsholder",
    "Copy to other groups": "Kopier aktivitet til andre hold",
    "Copy to other class": "Kopier til andre hold",
    "Copying Group": "Kopierer hold",
    "Finalizing group copy...": "Færdiggør holdkopi...",
    "Group copy completed successfully!": "Holdkopi afsluttet med succes!",
    "Successfully copied": "Kopieret med succes",
    "Group copy completed with errors": "Holdkopi afsluttet med fejl",
    "courses failed": "forløb fejlede",
    "View failed courses": "Vis fejlede forløb",
    "Copying group settings, apps, and other elements...": "Kopierer holdindstillinger, apps og andre elementer...",
    "courses completed": "forløb fuldført",
    "Starting...": "Starter...",
    "Copying course": "Kopierer forløb",
    "of": "af",
    "Failed to copy group": "Kunne ikke kopiere hold",
    Corrected: "Rettet",
    Correct: "Korrekt",
    "Correct answer": "Korrekt svar",
    "Correct answer(s)": "Korrekt(e) svar",
    "Correct assignment": "Ret opgave",
    "Correct using DirectEdit": "Ret med DirectEdit",
    "Corresponding answer": "Tilhørende svar",
    course: "forløb",
    Course: "Forløb",
    "Courses are the top building block of content":
        "Forløb er øverste byggesten i dit læringsindhold",
    "Course copied": "Forløb kopieret",
    Counsellor: "Vejleder",
    Counsellors: "Vejledere",
    "Counsellors list": "Vejleder liste",
    "Course created": "Forløb oprettet",
    "Course moved": "Forløb flyttet",
    "Course name": "Forløbsnavn",
    "Course progression": "Forløbsprogression",
    "Course removed": "Forløb fjernet",
    "Course statistics": "Forløbsstatistik",
    "Course title": "Forløbstitel",
    courses: "Forløb",
    Courses: "Forløb",
    "Courses are comparable to chapters in a book, and contain several lessons to provide at logical structure for the class content. Make sure to create a course for all of your major subjects of the class.":
        "Forløb kan sammenlignes med kapitler i en bog, og indeholder lektioner for at gruppere læringsindhold. Giv en logisk struktur til holdets indhold! Sørg for at oprette forløb til alle store emner på dit hold.",
    Create: "Opret",
    "Create account using": "Opret bruger med",
    "Create another": "Opret endnu en",
    "Create a class": "Opret et hold",
    "Create a course": "Opret et forløb",
    "Create a lesson": "Opret en lektion",
    "Create a lesson by inserting its name. You can hide this lesson so students will not see it.":
        "Opret en lektion ved at skrive en titel. Du kan skjule denne lektion, så eleverne ikke kan se den.",
    "Create a new discussion and get opinions from other members":
        "Opret en ny debat og få meninger fra andre medlemmer",
    "Create an account": "Opret en bruger",
    "Create assignment": "Opret opgave",
    "Create assignments in bulk": "Opret afleveringer i bunker",
    "Create and release feedback": "Opret og frigiv feedback",
    "Create and show": "Opret og vis",
    "Create board item": "Tilføj opslag",
    "Create class": "Opret hold",
    "Create collection": "Opret kollektion",
    "Create consultation": "Opret konsultation",
    "Create course": "Opret forløb",
    "Create discussion": "Opret debat",
    "Create feedback": "Opret feedback",
    "Create fields and drag them to the desired location on the image. You can switch between image and text. Adjust the 'matches with' field to group together fields, that can be placed in the same places in the picture.":
        "Opret felter og træk dem til det rigtige sted på billedet. Du kan vælge imellem billeder og tekst. Justér 'Matcher med' feltet for at gruppere felter der gerne må ombyttes på billedet.",
    "Create flashcards": "Opret flashkort",
    "Create folder": "Opret mappe",
    "Create image label": "Opret billedetikette",
    "Create geogebra": "Opret Geogebra aktivitet",
    "Create Geogebra element": "Opret Geogebra aktivitet",
    "Create group": "Opret hold",
    "Create lesson": "Opret lektion",
    "Create link": "Opret link aktivitet",
    "Create media": "Opret mediaet",
    "Create new activity": "Opret ny aktivitet",
    "Create new conversation": "Opret ny samtale",
    "Create new course": "Opret nyt forløb",
    "Create new discussion": "Opret ny debat",
    "Create new group": "Opret nyt hold",
    "Create new material": "Opret ny lektion",
    "Create new question": "Opret nyt spørgsmål",
    "Create news post": "Opret nyhed",
    "Create now": "Opret nu",
    "Create conference post": "Opret forum tråd/spørgsmål",
    "Create question": "Opret spørgsmål",
    "Create questionnaire": "Opret spørgeskema",
    "Create quiz": "Opret quiz",
    "Create quiz question": "Opret quizspørgsmål",
    "Create question and show": "Opret spørgsmål og vis",
    "Create quiz and show": "Opret quiz og vis",
    "Create permission group": "Opret rolle",
    "Create pinboard": "Opret opslagstavle",
    "Create post": "Opret opslag",
    "Create sub group": "Opret underhold",
    "Create subject": "Opret emne",
    "Create submission": "Opret opgaveaflevering",
    "Create text": "Opret tekst",
    "Create text label": "Opret tekstetikette",
    "Create timeline": "Opret tidslinje",
    "Create topic": "Opret underemne",
    "Create user": "Opret bruger",
    "Create widget": "Opret widget",
    "Create your account": "Opret din bruger",
    "Create your first class": "Opret dit første hold",
    "Create your first class and invite students":
        "Opret dit første hold og inviter brugere",
    "Create your first message": "Opret din første besked",
    Created: "Oprettet",
    "Created learning activities": "Oprettede læringsaktiviteter",
    "created the assignment": "oprettede afleveringen",
    Croatian: "Kroatisk",
    "Current plan": "Nuværende plan",
    "Currently Excluded Groups": "Aktuelt Ekskluderede Hold",
    "Currently unavailable": "Ikke tilgængelig lige nu",
    "Custom DPA": "Tilpasset DPA",
    "Custom pricing": "Tilpasset pris",
    "Custom integrations": "Tilpassede integrationer",
    CVC: "CVC",
    Czech: "Tjekkisk",
    Danish: "Dansk",
    Dansk: "Dansk",
    "Dark blue": "Mørkeblå",
    dashboard: "Overblik",
    Dashboard: "Overblik",
    "dashboard-new-teacher-greeting":
        "Du har endnu ikke nogen aktive hold på edaptio. <br/> Klik nedenfor for at oprette dit første hold.",
    "Data display": "Datavisning",
    "Download PDF": "Download PDF",
    "Creating PDF…": "Danner PDF…",
    "The PDF could not be created. Try again.": "PDF'en kunne ikke dannes. Prøv igen.",
    Date: "Dato",
    "Date saved": "Dato gemt",
    "Dedicated support": "Dedikeret support",
    "Default language": "Standard sprog",
    Definition: "Definition",
    "Delete group information": "Fjern information",
    Delete: "Slet",
    "Delete match": "Fjern match",
    "Delete match set": "Fjern matchsæt",
    "Delete pinboard item?": "Slet opslag?",
    "Delete submission": "Slet aflevering",
    "Depending on course(s)": "Afhænger af forløb",
    "Depending on following courses": "Afhænger af følgende forløb",
    Description: "Beskrivelse",
    "Description too long": "Beskrivelser for lang",
    "Descriptive text": "Beskrivelsestekst",
    Design: "Design",
    Deutsch: "Tysk",
    Dialog: "Dialog",
    Difficulty: "Sværhedsgrad",
    "An image copied from Word or Excel could not be pasted. Copy the image on its own, or save it as a file and insert it from there.":
        "Et billede kopieret fra Word eller Excel kunne ikke indsættes. Kopier billedet for sig selv, eller gem det som en fil og indsæt det derfra.",
    "Direct edit": "Direct edit",
    "Disable assignment links in assignments app":
        "Slå links fra i afleveringer-app (brug kun som oversigt).",
    "Disallow copy/paste in assignment submissions":
        "Deaktiver kopier/indsæt i opgaveafleveringer",
    "Copy/paste is disabled for this assignment":
        "Kopier/indsæt er deaktiveret for denne opgave",
    "Drag and drop is disabled for this assignment":
        "Træk og slip er deaktiveret for denne opgave",
    "Disable video": "Slå video fra",
    "Disable audio": "Slå lyd fra",
    Discard: "Kassér",
    discussions: "Debatter",
    Discussions: "Debatter",
    "Display news from a specific class by selecting one below":
        "Vis nyheder fra et bestemt hold ved at vælge et nedenfor",
    "Dive deeper by choosing course and lesson.":
        "Dyk dybere ned ved at vælge forløb og lektion.",
    Document: "Dokument",
    Documents: "Dokumenter",
    Done: "Færdig",
    Download: "Hent",
    "Download as csv": "Download som csv",
    "Download attachment": "Download fil",
    "Download original file": "Hent original fil",
    "Download zip": "Hent zip fil",
    "Do not create sub group": "Opret ikke underhold",
    "Do not join": "Tilmeld mig ikke",
    "Do not have an account?": "Har du ikke en bruger?",
    "Do not use deadline": "Brug ikke afleveringsdato",
    "Do you have any other tasks for your friend Olly, the virtual teaching assistant?":
        "Har du andre opgaver til din ven Olly, den virtuelle undervisningsassistent?",
    "Do you know the answer?": "Kender du svaret?",
    "Do you need help?": "Har du brug for hjælp?",
    "Do you really want to leave? you have unsaved changes!":
        "Er du sikker på du vil forlade siden? Du har ting du ikke har gemt!",
    "Do you want to abandon the process?":
        "Har du lyst til at afslutte processen?",
    "Do you want to continue, but only copy new elements?":
        "Har du lyst til at fortsætte, men kun kopiere nye aktiviteter?",
    "Do you want to delete this answer?": "Vil du gerne slette dette svar?",
    "Do you want to delete this consultation?":
        "Vil du gerne slette denne konsultation?",
    "Do you want to delete this message for all members?":
        "Er du sikker på du vil slette denne besked for alle medlemmer af samtalen?",
    "Do you want to enable camera after joining call?":
        "Vil du starte dit kamera når du kommer ind i opkaldet?",
    "Do you want to end this call for all participants or just leave this conversation?":
        "Vil du afslutte opkaldet for alle medlemmer, eller bare forlade opkaldet?",
    "Do you want to evenly distribute the rest of the users assignments afterwards?":
        "Vil du automatisk omfordele fremtidige afleveringer jævnt for brugeren efter?",
    "Do you want to remove": "Vil du fjerne",
    "Do you want to remove member from this call?":
        "Vil du fjerne {insertion} fra dette opkald?",
    "Do you want to you want to leave current call?":
        "Vil du forlade dette opkald?",
    "Do you want to you want to leave current webinar?":
        "Vil du forlade dette webinar?",
    "Do you want to synchronize elements that have already been copied?":
        "Har du lyst til at synkronisere aktiviteter, som allerede er blevet kopieret før?",
    "Do you want to test out some of our math materials?":
        "Har du lyst til at prøve et udpluk af vores materialer til matematik?",
    "Do you wish to join the institution": "Vil du tilmelde dig institutionen",
    "Do you wish to share this with everyone?":
        "Kunne du tænke dig at dele dette med alle?",
    Downgrade: "Nedgradér",
    "Drag and drop answers to the dashed boxes with the categories":
        "Træk og slip svarene til de stiplede felter med kategorierne",
    "Drag and drop labels into this box to create alternative (wrong) labels":
        "Træk og slip etiketter ind i denne boks for at oprette alternative (forkerte) etiketter",
    "Drag and drop on image": "træk og slip på billede",
    "Drag and drop options to the dashed boxes with the answers":
        "Drag'n'drop etiketter til de stiplede bokse med svarene",
    "Drag and drop to edit the sort order of the apps and activate/deactivate the app using the lever. You can also hide apps from the students":
        "Drag'n'drop for at ændre rækkefølgen af dine apps og aktiver/deaktiver dem ved at slå knappen til/fra. Du kan også skjule apps for dine brugere",
    Drama: "Dramatik",
    "Drop new learning element here": "Træk nyt læringslement her",
    "Dropout members": "Udmeldte medlemmer",
    "Dropped out": "Udmeldt",
    Due_date: "Afleveringsdato",
    "Due date": "Afleveringsdato",
    "Due date required": "Afleveringsdato påkrævet",
    Duplicate: "Duplikér",
    "Duplicate assignment": "Duplikér opgave",
    "Duplicate flashcard": "Duplikér flashkort",
    "Duplicate learning activity": "Duplikering af læringsaktivitet",
    "Duplicate question": "Duplikér spørgsmål",
    Dutch: "Hollandsk",
    Economics: "Økonomi",
    "Edaptio group": "Edaptio hold",
    "Edaptio primary": "Edaptio primær",
    "Edaptio secondary": "Edaptio sekundær",
    Edit: "Rediger",
    "Edit assignment": "Rediger opgave",
    "Edit audio": "Redigér lyd",
    "Edit payment method": "Rediger betalingsmetode",
    "Edit pinboard": "Rediger opslagstavle",
    "Edit board item": "Rediger opslag",
    "Edit collection": "Rediger kollektion",
    "Edit consultation": "Rediger konsultation",
    "Edit course": "Rediger forløb",
    "Edit courses order": "Rediger rækkefølge af forløb",
    "Edit discussion": "Rediger debat",
    "Edit external link": "Redigér eksternt link",
    "Edit feedback": "Rediger feedback",
    "Edit file": "Redigér fil",
    "Edit flashcard": "Redigér flashkort",
    "Edit flashcards": "Redigér flashkort",
    "Edit Geogebra element": "Rediger Geogebra aktivitet",
    "edit-group": "Holdindstillinger",
    "Edit group": "Rediger hold",
    "Edit group information": "Rediger gruppeinformation",
    "Edit group name": "Rediger holdnavn",
    "Edit holiday": "Rediger ferie/helligdag",
    "Edit image": "Redigér billede",
    "Edit image label": "Rediger billedetikette",
    "Edit learning element": "Rediger læringsaktivitet",
    "Edit material": "Redigér lektion",
    "Edit materials order": "Rediger rækkefølge af lektioner",
    "Edit message": "Redigér besked",
    "Edit news post": "Redigér nyhedsopslag",
    "Edit notebook": "Redigér notesbog",
    "Edit permission group": "Rediger rolle",
    "Edit post": "Rediger opslag",
    "Edit question": "Rediger spørgsmål",
    "Edit questionnaire": "Rediger spørgeskema",
    "Edit questions": "Rediger spørgsmål",
    "Edit quiz": "Rediger quiz",
    "Edit one learning element at a time. Save changes in order to continue editing.":
        "Rediger ét læringslement af gangen. Gem dine ændringer for at redigere en ny aktivitet.",
    "Edit timeline": "Rediger tidslinje",
    "Edit selected learning element": "Rediger den valgte læringsaktivitet",
    "Edit selected user": "Rediger valgte bruger",
    "Edit subject": "Rediger emne",
    "Edit tests": "Rediger tests",
    "Edit text": "Redigér tekst",
    "Edit text label": "Rediger tekstetikette",
    "Edit topic": "Rediger underemne",
    "Edit user": "Rediger bruger",
    Element: "Element",
    "Element already in lesson": "Aktiviteten er allerede på lektionen",
    "Element moved": "Læringsaktivitet flyttet",
    Elements: "aktiviteter",
    "Edit comment": "Redigér kommentar",
    "Edit video": "Redigér video",
    "Edit vimeo": "Redigér vimeo",
    "Edit youtube": "Redigér youtube",
    Embedded: "Indlejret",
    "Enable camera": "Slå kamera til",
    "Enable video": "Slå video til",
    "Enable audio": "Slå lyd til",
    Email: "Email",
    email: "Email",
    "Email, chat & onboarding support": "Email, chat & onboarding support",
    "Email & chat support": "Email & chat support",
    "Email / Username": "Email / brugernavn",
    "Email already exists": "Email eksisterer allerede i systemet",
    "Email support": "Email support",
    "End chat": "Afslut chat",
    "End for all": "Afslut for alle",
    English: "Engelsk",
    "Enter class code": "Indtast holdets kode",
    "Enter colleague email": "Skriv kollegas email",
    "Enter your email address and we will send you a new temporary password":
        "Skriv din email-adresse og vi sender dig et nyt midlertidigt kodeord",
    "Enter your new payment details": "Indtast dine nye betalingsoplysninger",
    "Enter your nickname to join this call":
        "Skriv dit kaldenavn for at joine opkaldet",
    "Enter your payment details": "Indsæt dine betalingsdata",
    Error: "Fejl",
    "Error occurred while trying to load your text. Please contact us to resolve this issue or simply re-enter text.":
        "Der skete en fejl da vi prøvede at indlæse din tekst. Kontakt supporten hvis det bliver ved med at ske, og så fixer vi det.",
    "Error occurred during video chat. Please contact us to resolve this issue or try to restart video chat.":
        "Fejl ved etablering af forbindelse. Venligst kontakt supporten eller prøv at genstarte videoopkaldet.",
    "Error occurred while try sign up":
        "Det skete en fejl ved oprettelse af bruger",
    "Error: time must be in HH:MM:SS format":
        "Fejl: tid skal være TT:MM:SS format",
    Esperanto: "Esperanto",
    "Evaluate all words": "Evaluér alle ord",
    "Even more storage": "Endnu mere lagerplads",
    Event: "Begivenhed",
    Events: "Begivenheder",
    Exam: "Eksamen",
    "exam mode": "eksamenstilstand",
    Exams: "Eksamener",
    "Exam mode": "Eksamineringstilstand",
    "Exam mode limits the students communication features for an entire team during an exam. Can be turned on/off at any time, and works right away.":
        "Eksamineringstilstand begrænser brugernes kommunikationsmuligheder på Edaptio, så man kan holde eksamener. Funktionen kan blive slået fra/til til enhver tid og virker øjeblikkeligt.",
    "Exit fullscreen": "Luk fuld skærm",
    Expand: "Fold ud",
    "Expand all": "Fold all ud",
    "Expiration date of your ongoing subscription plan":
        "Udløbsdatoen for din igangværende abonnementsplan",
    "Expiry date": "Udløbsdato",
    Expressions: "Udtryk",
    "External link": "Eksternt link",
    "External service forgotten error":
        "Du kan ikke anmode om nyt kodeord på denne institution, da i anvender et eksternt system til at logge jer ind. Kontakt administrationen på din institution.",
    "External service not linked":
        "Ekstern service ikke er linket til nogen bruger",
    "External user id": "Eksternt bruger-id",
    "Extra items (uncategorised)": "Ekstra elementer (ikke kategoriseret)",
    "Failed to activate video chat. Please contact us.":
        "Video chat aktivering fejlede. Kontakt venligst supporten. ",
    "Failed to delete information": "Kunne ikke fjerne information",
    "Failed to exclude group": "Kunne ikke ekskludere hold",
    "Failed to load excluded groups": "Kunne ikke indlæse ekskluderede hold",
    "Failed to remove group from exclusion list": "Kunne ikke fjerne hold fra eksklusionsliste",
    "Failed to search groups": "Kunne ikke søge hold",
    "Failed to join video chat. Maybe you re not a participant of video chat. Try to ask to join":
        "Der skete en fejl med at tilgå videochatten. Maybe er du ikke medlem af videochatten. På at bede om adgang. ",
    "Failed to lock\\unlock board": "Fejl ved lås\\lås op af opslagstavle",
    "Failed to lock\\unlock board item": "Fejl ved lås\\lås op af opslag",
    "Failed to remove board item": "Fejl ved fjern opslag",
    "Failed to join video call": "Kunne ikke deltage i videoopkald",
    "Failed to load consultation": "Kunne ikke hente konsultation",
    "Failed to remove consultation": "Kunne ikke slette konsultation",
    "Failed to save board item": "Fejl ved gem opslag",
    "Failed to save consultation": "Kunne ikke gemme konsultation",
    "Failed to save information": "Kunne ikke gemme information",
    "Failed to send notification": "Kunne ikke sende notifikation",
    "Failed to start video chat. Please contact us.":
        "Vi kunne ikke starte videochatten. Kontakt venligst support.",
    "Failed to subscribe to board updates. Try to refresh board":
        "Fejl ved oprettelse af forbindelse til opslagstavle-opdateringer. Prøv at genopfriske opslagstavle.",
    "Failed to subscribe to conference updates. Try to refresh conference":
        "Fejl ved oprettelse af forbindelse til forum-opdateringer. Prøv at genopfriske forum.",
    "Failed to subscribe to news updates. Try to refresh news":
        "Fejl ved oprettelse af forbindelse til nyheder-opdateringer. Prøv at genopfriske nyheder.",
    "Failed to subscribe to page updates. Try to refresh the page":
        "Fejl ved oprettelse af forbindelse til side-opdateringer. Prøv at genopfriske side.",
    "Failed to subscribe to post answers updates. Try to refresh post answers":
        "Fejl ved oprettelse af forbindelse til opslag-svar-opdateringer. Prøv at genopfriske opslag svar.",
    FAQ: "Ofte stillede spørgsmål",
    Feedback: "Feedback",
    "Feedback created": "Feedback oprettet",
    "Feedback for this quiz try": "Feedback til dette quiz forsøg",
    "Feedback from past assignments": "Feedback fra tidligere afleveringer",
    "Feedback with this answer": "Feedback ved denne svarmulighed",
    "Feedback for answer": "Feedback til svar",
    "Feedback on this answer": "Feedback til dette svar",
    "Feedback released": "Feedback frigivet",
    "Feedback saved": "Feedback gemt",
    Female: "Kvinde",
    Fields: "Felter",
    File: "Fil",
    Files: "Filer",
    "File added": "Fil tilføjet",
    "File removed": "Fil fjernet",
    "File saved": "Fil gemt",
    "File path": "Filsti",
    "File too big, please upgrade your account to increase file size limit. (Trial limit:":
        "Filen er for stor. Du kan opgradere din Edaptio konto hvis du vil oploade større filer. (Nuværende begrænsning: ",
    "Files added": "Filer tilføjet",
    file_sharing: "Fildeling",
    "File sharing": "Fildeling",
    "Fill it in to log in": "Skriv det her for at logge ind",
    Filter: "Filtrér",
    "Fill in the blank": "Fill in the blank",
    "Fill in the blank (Cloze)": "Fill in the blank (Cloze)",
    "Find members by email": "Find medlemmer via mail",
    Finish: "Færdig",
    "Finish quiz": "Afslut quiz",
    "Fix Student Record": "Ret studenterregistrering",
    "Fix UMS students": "Ret UMS studerende",
    "Fix UMS Students": "Ret UMS kursister",
    "Fix UMS students description": "Indtast et studerendeadministrations-ID for at rette og synkronisere studenterdata fra universitetets ledelsessystem.",
    "Fixed user details": "Rettede brugeroplysninger",
    "Student Administration ID": "Studerendeadministrations-ID",
    "Student ID is required": "Kursist-ID er påkrævet",
    "Student ID must be a valid number": "Kursist-ID skal være et gyldigt tal",
    "Student record has been successfully fixed": "Studenterregistrering er blevet rettet",
    "Student not found in university system": "Studerende ikke fundet i universitetssystemet",
    "An error occurred while fixing the student record": "Der opstod en fejl under rettelse af studenterregistreringen",
    "This page is for fixing missing students who has purged when UMS created the new ID's without notifying us.": "Denne side er til at rette manglende studerende, der blev slettet, da UMS oprettede nye ID'er uden at give os besked.",
    "INPUT THE STUDENT ID FROM UMS HERE": "INDTAST KURSIST-ID FRA UMS HER",
    "SUCCESS: user fixed": "SUCCES: bruger rettet",
    "ERROR: user not found": "FEJL: bruger ikke fundet",
    "The student is not in Edaptio currently.": "Den studerende er ikke i Edaptio i øjeblikket.",
    Finnish: "Finsk",
    Firstname: "Fornavn",
    "First handin": "Første aflevering",
    "Firstname should not be empty": "Fornavn kan ikke være tomt",
    "Fixed submission date": "Fast afleveringsdato",
    "Flashcards collection": "Flashcards samling",
    "Flashcards collection creation": "Opret flashcards",
    "Flashcards collection edit": "Redigér flashcards",
    "Flashcards tips":
        "Brug {param1} for at skifte kort og {param2} til at vende kortet" /* Write with params like in en_EN.js */,
    "Flexible submission date": "Fleksibel afleveringsdato",
    Float: "Decimaltal",
    Folders: "Mapper",
    "Folder added": "Mappe tilføjet",
    "Folder removed": "Mappe fjernet",
    "Folder saved": "Folder gemt",
    "Following invites will be sent via email":
        "Følgende medlemmer via blive inviteret via mail",
    For: "Til",
    "Forgot password?": "Glemt kodeord?",
    "Forgotten password": "Glemt kodeord",
    "for clarification.": "til afklaring",
    "For the best experience, we recommend switching to a computer.":
        "For at få den bedste oplevelse anbefaler vi, at du skifter til en computer.",
    Fraction: "Brøk",
    Fractions: "Brøker",
    Flashcard: "Flashkort",
    flashcards: "Flashkort",
    Flashcards: "Flashkort",
    Free: "Gratis",
    French: "Fransk",
    From: "Fra",
    "From the date your plan will switch to plan":
        "Fra {dato} skifter din plan til {plan}" /* Translate with params */,
    "from this call?": "fra dette opkald?",
    Front: "Forside",
    Full: "Fuld",
    Fullscreen: "Fuld skærm",
    "gave feedback for the assignment": "gav feedback til afleveringen",
    Gender: "Køn",
    General: "Generelt",
    "General chat": "Generel chat",
    "General feedback": "Generel tilbagemelding",
    "General question types": "Generelle spørgsmålstyper",
    "General settings": "Generelle indstillinger",
    geogebra: "Geogebra",
    Geogebra: "Geogebra",
    "Geogebra creation": "Opret Geogebra",
    "Geogebra edit": "Rediger Geogebra",
    "Geogebra element": "Geogebra element",
    "Geogebra element removed": "Geogebra element fjernet",
    "Geogebra id": "Geogebra id",
    "Geogebra link or ID": "Geogebra link eller ID",
    Geography: "Geografi",
    German: "Tysk",
    "Get help from Olly": "Få hjælp af Olly",
    "Get mail for every debate/news/comment in Edaptio": "Få mail for hver debat/nyhed/kommentar i Edaptio",
    "Get mail for every new message in Edaptio": "Få mail for hver ny besked i Edaptio",
    "Get mail when feedback is released": "Få mail når feedback frigives",
    "Get started": "Kom igang",
    "Get started using Edaptio for free": "Kom gratis igang med Edaptio",
    "Get started with Edaptio": "Kom igang med Edaptio",
    "Get this code/URL from your teacher.":
        "Få denne kode/URL fra din underviser",
    "Get submission as zip": "Hent afleveringer som zip",
    "Go back to what you have been doing and get a notification when Olly is done":
        "Gå tilbage til det, du har været i gang med, og få en notifikation, når Olly er færdig",
    "Go back to where you came from":
        "Gå tilbage til det sted, hvor du kom fra",
    "Go to group": "Gå til hold",
    "Go to guide": "Gå til guide",
    "Go to link": "Gå til link",
    "Go to the team": "Gå til holdet",
    "Go to the lesson view to add learning elements!":
        "Gå til lektionen for at tilføje læringsaktiviteter!",
    "Good afternoon": "Godeftermiddag,",
    "Good evening": "Godaften,",
    "Good morning": "Godmorgen,",
    Google: "Google",
    "Google linked": "Google linked",
    Grade: "Karakter",
    "Grade scale": "Karakterskala",
    "grade_scale.danish": "Dansk 7-trins skala",
    "grade_scale.letters": "Bogstaver A-F",
    "grade_scale.numbers": "Tal 1-6",
    "grade_scale.romanDTU": "Romertal I-IV",
    Graded: "Rettet",
    Graphical: "Grafisk",
    "Gray": "Grå",
    Greek: "Græsk",
    Group: "Hold",
    "Group with": "Gruppér med",
    group_courses: "Forløb",
    groups: "Hold",
    "Groups in exam mode": "Hold i eksamenstilstand",
    "group-information": "Information",
    "group-statistics": "Holdstatistik",
    "Group archived": "Hold arkiveret",
    "Group created": "Hold oprettet",
    "Group hand-in allowed": "Gruppeaflevering tilladt",
    "Group ID": "Hold-ID",
    "Group is already in the exclusion list": "Holdet er allerede på eksklusionslisten",
    "Group is not in the exclusion list": "Holdet er ikke på eksklusionslisten",
    "Group name": "Holdnavn",
    "Group news": "Holdnyheder",
    "Group saved": "Hold gemt",
    "Group successfully excluded": "Hold blev ekskluderet",
    "Group successfully removed from exclusion list": "Hold blev fjernet fra eksklusionsliste",
    "Group type": "Holdtype",
    "Group unarchived": "Hold fjernet fra arkiv",
    Half: "Halv",
    "Hatian Creole": "Hatian Creole",
    "Hand down": "Hånd ned",
    "Hand up": "Hånd op",
    "Handed in": "Afleveret",
    "Handed in after deadline": "Afleveret efter deadline",
    "has a hand up": "har en hånd oppe",
    "has started a video-chat. Click here to attend:":
        "har startet en video-chat. Klik her for at deltage:",
    "Have you received a class code from your teacher? Then click the “join now” button and become a part of your first class.":
        'Har du fået en kode af din underviser? Så klik på "tilmeld dig nu" og bliv en del af holdet',
    Help: "Hjælp",
    "Help center": "Hjælpecenter",
    "Here isn't added courses yet": "Ingen forløb fundet",
    "Here you can copy all your class contents to another class. Remember that elements you have previously copied will only be synchronized, and not copied again.":
        "Her kan du kopiere al indhold på dit hold til et andet hold. Husk at aktiviteter som du har kopieret før, ikke vil blive kopieret igen, men derimod synkroniseret.",
    "Here you can put groups in exam mode. Exam mode means that all users in the particular group can not use any communication tools on the platform. E.g messages, news and conference":
        "Her kan du sætte hold i eksamenstilstand. Eksamenstilstand betyder, at alle brugere på pågældende hold ikke kan bruge nogen kommunikationsværktøjer på platformen. Så som beskeder, nyheder eller debat.",
    "Hey, I am busy at the moment!": "Hej, jeg har travlt i øjeblikket!",
    "Hey! I am Olly, the virtual teaching assistant!":
        "Hej! Jeg er Olly, den virtuelle undervisningsassistent!",
    "Let's begin!": "Lad os begynde!",
    "Hey, Olly has your content ready for review":
        "Hej, Olly har dit indhold klar til gennemsyn",
    "Hey! Olly failed to create learning activities from of the uploaded source":
        "Hey! Olly kunne ikke oprette læringsaktiviteter fra den uploadede ressource",
    "Hey Edaptio, I am interested in a tailored offer for you platform. My contact information is:":
        "Hej Edaptio, jeg er interesseret i et skræddersyet tilbud til din platform. Mine kontaktoplysninger er:",
    "HH:MM:SS": "TT:MM:SS",
    "Hidden lesson": "Skjult lektion",
    "Hide element": "Skjul element",
    "Hide menu": "Skjul menu",
    "Hide/show side menu": "Skjul/vis sidemenu",
    "Hide non due date assignments": "Skjult afleveringer uden frist",
    Hidden: "Skjult",
    "Hidden assignment": "Skjult opgave",
    "Hidden course": "Skjult forløb",
    "Hidden folder": "Skjult mappe",
    "Hidden from students": "Skjult for brugere",
    "Hidden material": "Skjult lektion",
    "Hidden submission": "Skjult aflevering",
    Inaccessible: "Utilgængelig",
    Public: "Offentlig",
    "This assignment is not accessible": "Denne opgave er ikke tilgængelig",
    Visibility: "Synlighed",
    Hindi: "Hindi",
    History: "Historie",
    Home: "Hjem",
    "How do i log in?": "Hvordan logger jeg ind?",
    "How do you want to create your activity?":
        "Hvordan ønsker du at oprette {name}?" /* Translate with param */,
    "How to get started?": "Hvordan kommer jeg igang?",
    Hungarian: "Ungarsk",
    Icelandic: "Islandsk",
    Identifier: "Identifier",
    "I am using another platform": "Jeg bruger en anden platform",
    "I agree": "Jeg accepterer",
    "I agree to the Terms and Conditions and default Notifications settings":
        "Jeg accepterer {termsLink} og de generelle {notifLink}" /* Translate with params like in en_US file */,
    "I can help you create content for your lessons. Just follow the steps and put me to work!":
        "Jeg kan hjælpe dig med at oprette læringsindhold til dine lektioner. Følg blot trinene, og sæt mig i gang!",
    "I don’t find the platform valuable": "Jeg fandt ikke værdi i platformen",
    "I have read and understood this text":
        "Jeg har læst og forstået denne tekst",
    "If unchecked, the user will be presented with all words form the word list.":
        "Hvis ikke valgt, vil brugere blive præsenteret for alle ordene i ordlisten.",
    "If you have been sent here by your teacher, then you already have a login. So make sure to ask them how to login and for your credentials.":
        "Hvis du er blevet sendt herhen af din underviser, så har du allerede et login. Spørg din underviser efter dine oplysninger.",
    'If you have downloaded your assignments via the "download as zip" button, then you can upload the feedback files directly here. We will automatically generate feedback and attach the files. Make sure you only upload files you have not uploaded before, and only for submissions you have not given feedback to already.':
        'Hvis du har hentet afleveringerne via "download som zip" knappen, så kan du uploade din feedback samlet her. Vi sørger for automatisk at generere feedback og vedhæfte filerne. Sørg for kun at uploade filer, som du ikke har uploadet før, og kun til afleveringer som du ikke allerede har rettet.',
    "If you're supposed to have access to this page, try refreshing.":
        "Hvis det er meningen at du skal have adgang til denne side, så prøv at genindlæse browservinduet.",
    "I'm sure": "Jeg er sikker",
    Image: "Billede",
    image: "Billede",
    "Image dimensions": "Billeddimensioner",
    "Image height": "Billedhøjde",
    "Image width": "Billedbredde",
    "image-drag-and-drop": "Træk og slip på billede",
    Import: "Importer",
    "Import data": "Importer data",
    "Import existing question": "Importér spørgsmål",
    "Import users": "Importer brugere",
    "Import wiris instance": "Importer et wiris spørgsmål",
    "In a test, all feedback is received at the end of the quiz.":
        "I en test får brugeren al feedback i slutningen af quizzen.",
    "Includes 10 active learners, €0.80/month for each additional learner":
        "Inkluderer 10 aktive studerende, 0,80 €/måned for hver ekstra studerende",
    "Includes 10 active learners, €1.60/month for each additional learner":
        "Inkluderer 10 aktive studerende, 1,60 €/måned for hver ekstra studerende",
    "Incorrect file name": "Forkert filnavn",
    Indonesian: "Indonesisk",
    information: "Information",
    Information: "Information",
    "Information deleted": "Information fjernet",
    "Information saved": "Information gemt",
    "Information title": "Titel",
    Innovation: "Innovation",
    "Input not email": "Input er ikke en email",
    "Input too short": "Input for kort",
    "Input valid date and time - or skip the deadline":
        "Tast korrekt dato og tid - eller vælg ikke at bruge deadline på denne opgave",
    "Input the class name and click create. You can always add members and co-teachers later under the members tab.":
        'Skriv holdnavnet og klik på opret. Du kan altid tilføje medlemmer og andre undervisere senere under "medlemmer" fanen.',
    "Insert a code received from your teacher in order to join the class":
        "Skriv holdkoden som du har modtaget fra din underviser for at tilmelde dig holdet.",
    "Insert a text below": "Indsæt en tekst nedenfor",
    "Insert audio": "Indsæt lyd",
    "Insert image": "Indsæt billede",
    "Insert video": "Indsæt video",
    "Insert file": "Indsæt fil",
    "Insert a word or phrase you want learners to hear.":
        "Indsæt et ord eller en sætning, som du ønsker, at eleverne skal høre.",
    "Insert your personal information and set up the platform’s language. You will be able to edit it later in the profile’s settings.":
        "Indsæt din personlige information og sæt dit foretrukne sprog. Du kan lave det om senere inde i din profil",
    Institution: "Institution",
    "Institution/company name": "Navn på institution/virksomhed",
    "Institution groups": "Institutionens hold",
    "Institution payments": "Betaling og forbrug",
    Institutions: "Institutioner",
    "Institution language": "Institutionssprog",
    "Institution settings": "Institutionsindstillinger",
    Integer: "Heltal",
    Interactive: "Interaktive",
    interactive_objects: "Geogebra",
    "Interactive exercise": "Interaktiv øvelse",
    "International economy": "International økonomi",
    "Intranet": "Intranet",
    Invalid: "Ugyldig",
    "Invalid class code": "Ugyldig holdkode",
    "Invalid form": "Ugyldig data sendt til server",
    "Invalid: Must be at least 1": "Ugydig: skal være minimum 1",
    "Invalid: Must be at most": "Ugydig: må højst være",
    "Invalid: Must be between 0 - 100": "Ugydig: Skal være imellem 0 og 100",
    Invite: "Inviter",
    "Invite colleagues": "Invitér kolleger",
    "Invite learners": "Invitér brugere",
    "Invite members": "Inviter medlemmer",
    "Invite members to your plan": "Inviter medlemmer til din plan",
    "Invite more": "Invitér flere",
    "Invite new learners sharing one of following":
        "Inviter nye elever via en af følgende",
    "Invite Participants": "Inviter medlemmer",
    "Invite participants via link": "Inviter medlemmer via link",
    "Invite plan members via email": "Inviter medlemmer via email",
    "Invited by": "Inviteret af",
    "Invites have been sent to your colleagues. They will be added to your institution as soon as they click the link in the email and complete the registration.":
        "Invitationerne er blevet sendt til dine kolleger. De vil blive tilføjet så snart de har gennemført registreringen på Edaptio.",
    "Invite(s) sent.": "Invitation(er) sendt",
    Italian: "Italiensk",
    Item: "Element",
    "It seems that there are no active elements in this class":
        "Det ser ud til at der ikke er nogen aktive {insertion} på dette hold",
    Japanese: "Japansk",
    Join: "Tilmeld",
    "Join class": "Tilmeld dig holdet",
    Joined: "Joinede",
    "Join call": "Deltag i opkald",
    "Join institution": "Join institution",
    "Join now": "Tilmeld dig her",
    "Join your class": "Tilmeld dig",
    "Join your first class": "Tilmeld dig dit første hold",
    "Join with a code": "Tilmeld dig med kode",
    "Join with code not allowed":
        "Tilmelding med kode er ikke tilladt for dette hold",
    "Keep training": "Bliv ved med at træne",
    Keyword: "Nøgleord",
    Korean: "Koreansk",
    label: "etikette",
    "Label group": "Etiketgruppe",
    "Labels not on image": "Etikette som ikke er på billedet",
    Language: "Sprog",
    "lang.da": "Dansk",
    "lang.en": "Engelsk",
    "Language saved": "Sprog gemt",
    "Language selection": "Vælg sprog",
    Lastname: "Efternavn",
    "Lastname should not be empty": "Efternavn kan ikke være tomt",
    "Last answered": "Seneste besvarelse",
    "Last modified": "Sidste aktivitet",
    Later: "Senere",
    "Latest activity": "Seneste aktivitet",
    "Latest answers": "Seneste svar",
    "Latest handin": "Seneste aflevering",
    "Latest sync": "Seneste synkronisering",
    "Latest try": "Seneste forsøg",
    Latin: "Latinsk",
    Latvian: "Lettisk",
    "Learning activities": "Læringsaktiviteter",
    learning_elements: "Læringsaktiviteter",
    "Learning activities added": "Læringsaktiviteter tilføjet",
    "Learning activities created by Olly are displayed below. You can keep, edit or discard each of them.":
        "Læringsaktiviteter skabt af Olly vises nedenfor. Du kan beholde, redigere eller kassere hver af dem.",
    "Learning activities to create": "Læringsaktiviteter til oprettelse",
    "Learning elements": "Læringsaktiviteter",
    "Learning element created": "Læringsaktivitet oprettet",
    "Learning element moved": "Læringsaktivitet flyttet",
    "Learning element removed": "Læringsaktivitet fjernet",
    "Learning element saved": "Læringsaktivitet gemt",
    "Learn more": "Lær mere",
    Leave: "Forlad",
    "Leave current video chat": "Forlad nuværende videoopkald",
    "Leave current webinar": "Forlad dette webinar",
    "Left us": "Forlod os",
    lesson: "Lektion",
    Lesson: "Lektion",
    "Lesson copied": "Lektion kopieret",
    "Lesson moved": "Lektion flyttet",
    "Lesson name": "Lektionsnavn",
    "Lesson title": "Lektionstitel",
    lessons: "Lektioner",
    Lessons: "Lektioner",
    "let all in": "lad alle komme ind",
    "Let us know why you are leaving:": "Fortæl of hvorfor du forlader os:",
    "Let’s begin!": "Lad os gå i gang!",
    Level: "Niveau",
    Levels: "Niveauer",
    link: "link",
    Link: "Link",
    "Link copied!": "Link kopieret!",
    "Link course to group": "Link forløb til hold",
    "Link element to group": "Link læringsaktivitet til hold",
    "Link file to group": "Link fil til hold",
    "Link learning element to group": "Link læringsaktivitet til hold",
    "Link lesson to group": "Link lektion til hold",
    "Link text": "Link tekst",
    "Link to group": "Link til hold",
    "Link to join to video chat": "Link til adgang til video chat",
    Links: "Link",
    "List of participants": "Medlemsliste",
    "List of selected attachments": "Valgte filer til aflevering",
    "Load all comments": "Hent alle kommentarer",
    "Load earlier": "Hent tidligere",
    "Load external quiz": "Indlæs ekstern quiz",
    "Load flashcards’ preview": "Hent & se flashcards",
    "Load more": "Hent mere",
    "Load pinboard items": "Hent opslag",
    "Load student submissions": "Indlæs afleveringsoversigt",
    Loading: "Indlæser",
    "Lock board": "Lås opslagstavle",
    "Lock board item": "Lås opslag",
    "Locked course. You have not yet completed the prerequisite course(s) for this course.":
        "Låst forløb. Du har endnu ikke fuldført det/de forløb som dette forløb afhænger af.",
    Login: "Log ind",
    "Login as": "Log ind som",
    "You cannot log in as this user, because they have permissions you do not have yourself:": "Du kan ikke logge ind som denne bruger, fordi brugeren har rettigheder, du ikke selv har:",
    "Your role needs these permissions too. They are set under Permission groups.": "Din rolle skal også have disse rettigheder. De sættes under Roller.",
    "Edaptio super administrator": "Edaptio-superadministrator",
    "at another institution": "på en anden institution",
    "Login failed with the following message":
        "Log ind fejlede med følgende meddelelse",
    Logout: "Log ud",
    "Log in as": "Log på som",
    "Login with": "Log ind med",
    "Log in with email": "Log ind med mail",
    "Log in with Facebook": "Log ind med Facebook",
    "Log in with Google": "Log ind med Google",
    "Log in with Microsoft": "Log ind med Microsoft",
    "Looking for a specific user? Search below.":
        "Leder du efter en bestemt bruger? Søg nedenfor.",
    "Looking to log in? Click here": "Leder du efter log ind? Klik her",
    "Lower border": "Nedre grænse",
    "Made by": "Lavet af",
    Male: "Mand",
    "Manage apps": "Tilføj/fjern apps",
    "Manage board item": "Administrér opslag",
    "Manage groups": "Administrer hold",
    "Manage institutions": "Administrer institutioner",
    "Manage moodle": "Administrer moodle",
    "Manage permissions": "Administrer tilladelser",
    "Manage users": "Administrer brugere",
    Mandatory: "Obligatorisk",
    "Maple TA": "Maple TA",
    Macedonian: "Makedonsk",
    "Mark all as read": "Markér alle som læst",
    "Mark completed": "Markér fuldført",
    "Mark as unread": "Markér som ulæst",
    "Mark student as self-study": "Markér som selvstuderende",
    "Mark unread": "Markér ulæst",
    "Marked as read": "Markeret som læst",
    match: "Match",
    Match: "Match",
    "Match case insensitive": "Skal IKKE skelne imellem store og små bogstaver",
    "Match case sensitive": "Skal skelne imellem store og små bogstaver",
    "Match options": "Match muligheder",
    "Match set": "Match sæt",
    "Match sets": "Match sæt",
    "Match with arrows": "Match med pile",
    "Matching cloze tag": "Matchende tekst hashtag",
    "Matching with": "Matcher med",
    "match-wiris": "Wiris match",
    material: "Lektion",
    material_objects: "Lektion",
    materials: "Lektioner",
    "Material added": "Lektion tilføjet",
    "Material created": "Lektion oprettet",
    "Material deleted": "Lektion slettet",
    "Material group": "Materialehold",
    "Material removed": "Lektion fjernet",
    "Material not found": "Materiale blev ikke fundet",
    MathHero: "MatematikTutor",
    Mathematics: "Matematik",
    media: "medie",
    Media: "Medie",
    Member: "Medlem",
    Members: "Medlemmer",
    members: "Medlemmer",
    "Members can comment on news": "Medlemmer kan kommentere nyheder",
    "Members can post news": "Medlemmer kan slå nyheder op",
    "Members on plan": "Medlemmer på planen",
    Menu: "Menu",
    "Message marked as unread": "Meddelelse markeret som ulæst",
    Messages: "Beskeder",
    Microphone: "Mikrofon",
    Microsoft: "Microsoft",
    "Microsoft linked": "Microsoft linked",
    min: "min",
    "Minimum count characters":
        "Minimum {count} tegn" /* Translate with param count */,
    "Minimum number of assignments behind": "Minimum antal afleveringer bagud",
    "Minimum number of questions": "Minimum antal spørgsmål",
    "Miro Mind Maps": "Miro Mind Map",
    "Missing feedback": "Manglende feedback",
    Moderator: "Moderator",
    Moldavian: "Moldovisk",
    Montenegrin: "Montenegrinsk",
    Monthly: "Månedlig",
    "Monthly payment": "Månedlig betaling",
    "Monthly payment per active learner":
        "Månedlig betaling pr. aktive studerende",
    "months-full-array": [
        "Januar",
        "Februar",
        "Marts",
        "April",
        "Maj",
        "Juni",
        "Juli",
        "August",
        "September",
        "Oktober",
        "November",
        "December"
    ],
    "months-short-array": [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "Maj",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Okt",
        "Nov",
        "Dec"
    ],
    Moodle: "Moodle",
    "Moodle group": "Moodle hold",
    More: "Mere",
    "More active learners": "Flere aktive elever",
    "More settings": "Flere indstillinger",
    "More support options": "Flere supportmuligheder",
    "Most apps have a central action button - look for it in the same place as this one":
        "Det fleste apps har en central handlingsknap - kig efter den samme sted som denne",
    Move: "Flyt",
    "Move activity": "Flyt aktivitet",
    "Move all classes to exam mode": "Flyt alle klasser til eksamenstilstand",
    "Move here": "Flyt hertil",
    "Move lesson": "Flyt lektion",
    "Move to folder": "Flyt til anden mappe",
    ms_class_notebook: "Klassenotesbog",
    "Multiple choice": "Multiple choice",
    "multiple-choice": "Multiple choice",
    "multi-choice-wiris": "Wiris multiple choice",
    "Multiple choice questions": "Multiple choice spørgsmål",
    "Multiple choice settings": "Multiple choice indstillinger",
    Music: "Musik",
    "Must be a valid secure link (https)":
        "Skal være et validt sikkert link (https)",
    "Must be between": "Skal være imellem",
    Mute: "Slå lyd fra",
    Muted: "Lyd slukket",
    "Muted mic": "Mic af",
    "mute all": "mute alle",
    "My institution is not on the list": "Min institution er ikke på listen",
    Name: "Navn",
    "Name saved": "Navn gemt",
    "Need help?": "Brug for hjælp?",
    "Need more flexible options? Upgrade your plan today":
        "Brug for mere fleksible muligheder? Opgrader din plan idag!",
    Never: "Aldrig",
    "New assignment": "Ny opgave",
    "New consultation": "Ny konsultation",
    "New course released": "Nyt forløb frigivet",
    "New lesson released": "Ny lektion frigivet",
    "New email": "Ny email",
    "New field": "Nyt felt",
    "New flashcard creation": "Opret nyt flashcard",
    "New Geogebra element": "Nyt Geogebra element",
    "New image": "Nyt billede",
    "New individual due date": "Ny individuel afleveringsdato",
    "New information": "Ny information",
    "New learning activity has been created":
        "Der er blevet oprettet en ny læringsaktivitet",
    "New learning element": "Ny læringsaktivitet",
    "New learning element added": "Ny læringsaktivitet tilføjet",
    "New message": "Ny besked",
    "New Post": "Nyt opslag",
    "New question": "Nyt spørgsmål",
    "New quiz": "Ny quiz",
    "New password": "Nyt kodeord",
    "New pinboard item": "Nyt opslag",
    "New relation": "Ny relation",
    "New word": "Nyt ord",
    news: "Nyheder",
    News: "Nyheder",
    "News post creation": "Opret nyhed",
    "New password has been successfully sent via email":
        "Et nyt kodeord er blevet sendt via email",
    Next: "Næste",
    "Next assignment": "Næste aflevering",
    "Next assignment answer without feedback": "Næste aflevering uden feedback",
    "Next course": "Næste forløb",
    "Next lesson": "Næste lektion",
    "Next material": "Næste lektion",
    "Next month": "Næste måned",
    "Next payment scheduled for": "Næste betaling forfalder",
    "Next question": "Næste spørgsmål",
    "Next submission": "Næste aflevering",
    "Next submission without feedback": "Næste aflevering uden feedback",
    "Next topic": "Næste delemne",
    "Nice, you created a quiz question!":
        "Flot, du har lavet et quiz-spørgsmål!",
    No: "Nej",
    "No admins yet": "Ingen undervisere endnu",
    "No answers": "Ingen svar",
    "No assignments found": "Ingen afleveringer fundet",
    "No collections found": "Ingen kollektioner fundet",
    "No completed consultations": "Ingen færdiggjorte konsultationer",
    "No consultations to display": "Ingen konsultationer at vise",
    "No past consultations": "Ingen tidligere konsultationer",
    "No conversations": "Ingen samtaler",
    "No counsellors": "Ingen vejledere",
    "No course": "Uden for forløb",
    "No courses found": "Ingen forløb fundet",
    "No credit card required": "Intet kreditkort påkrævet",
    "No data to display":
        "Ingen {name} at vise" /* Translate with param like in en_US */,
    "No description": "Ingen beskrivelse",
    "No elements in this lesson": "Ingen aktiviteter i denne lektion",
    "No files": "Ingen filer",
    "No files or folders yet": "Ingen filer eller mapper endnu",
    "No files to export":
        "Ingen filer at eksportere. Har dine brugere afleveret endnu?",
    "No Geogebra elements found": "Ingen Geogebra aktiviteter fundet",
    "No group information created": "Ingen information oprettet",
    "No groups": "Ingen hold",
    "No groups found": "Ingen hold fundet",
    "No excluded groups found": "Ingen ekskluderede hold fundet",
    "No information": "Ingen information",
    "No learning elements found": "Ingen læringsaktiviteter fundet",
    "No materials found": "Ingen lektioner fundet",
    "No members": "Ingen medlemmer",
    "No members yet": "Ingen medlemmer endnu",
    "No messages found": "Ingen beskeder endnu",
    "No messages to display": "Ingen beskeder at vise",
    "No messages yet": "Ingen beskeder endnu",
    "No news found for this group": "Ingen nyheder på dette hold endnu",
    "No notifications": "Ingen notifikationer",
    "No, only visible for my institution":
        "Nej, kun tilgængeligt for min institution",
    "No participants": "Ingen deltagere",
    "No people found": "Ingen brugere fundet",
    "No people found. Keep typing a full email to invite people.":
        "Ingen personer fundet. Bliv ved med at taste emailen for at invite personer",
    "No permissions found": "Ingen tilladelser fundet",
    "No permission to access your microphone or\\and camera you (or your companions) may experience some problems.":
        "Du har ikke givet tilladelse til at vi må bruge microfon og/eller video. Dette kan give problemer for dig selv eller dine gæster i video-kaldet.",
    "No posts found": "Ingen opslag fundet",
    "No questions": "Ingen spørgsmål",
    "No questions found": "Ingen spørgsmål fundet",
    "No questionnaires found": "Ingen spørgeskemaer fundet",
    "No quizzes found": "Ingen quizzer fundet",
    "No results": "Ingen resultater",
    "No results yet": "Ingen resultater endnu",
    "No subjects": "Ingen emner",
    "No submission date": "Ingen afleveringsdato",
    "No text": "Ingen tekst",
    "No title": "Ingen titel",
    "No topic": "Intet underemne",
    "No topics": "Ingen underemner",
    "No students": "Ingen studerende",
    "No tries yet": "Ingen forsøg endnu",
    "No upcoming consultations": "Ingen kommende konsultationer",
    "No videos found": "Ingen videoer fundet",
    "Non-profit": "Non-profit",
    none: "ingen",
    None: "Ingen",
    "Nope, thanks!": "Niks, tak!",
    Norwegian: "Norsk",
    Notifications: "Notifikationer",
    "Notify me": "Giv mig besked",
    "Notify Students": "Underret elever",

    // Realtime event toasts (src/components/misc/dialogue.vue)
    "A student submitted an assignment": "En elev har afleveret en opgave",
    "New submission": "Ny aflevering",
    "Feedback on your assignment is ready": "Der er feedback på din aflevering",
    "Feedback": "Feedback",
    "A student just took a quiz": "En elev har lige besvaret en quiz",
    "Quiz attempt": "Quizforsøg",
    "You passed a quiz": "Du har bestået en quiz",
    "Your quiz was graded": "Din quiz er blevet bedømt",
    "Quiz": "Quiz",
    "A new course is available": "Et nyt forløb er tilgængeligt",
    "New course": "Nyt forløb",
    "Not assigned to course": "Ikke tildelt til forløb",
    "Not enough data": "Ikke nok data",
    "Not active": "Ikke aktiv",
    "Not added": "Ikke tilføjet",
    "Not chosen": "Ikke valgt",
    "Not correct": "Ikke korrekt",
    "Not completed": "Ikke fuldført",
    "Not graded": "Ikke rettet",
    "Not passed": "Ikke bestået",
    "Not released": "Ikke frigivet",
    "Not submitted": "Ikke afleveret",
    "Not valid video chat session provided. Please restart video call normally Page reload will not help.":
        "Dette er ikke en valid video chat session. Venligst genstart video chat. Det hjælper ikke at genindlæse.",
    "Note that your new subscription plan will be activated on the date":
        "Bemærk, at dit nye abonnement vil blive aktiveret {dato}" /* Translate with param */,
    "Nothing has been shared with you yet":
        "Intet er blevet delt med dig endnu",
    "Notification settings": "Notifikationsindstillinger",
    "Editor settings": "Editor indstillinger",
    "Editor font size": "Editor skriftstørrelse",
    "Font size": "Skriftstørrelse",
    "font_size.normal": "Normal",
    "font_size.medium": "Medium",
    "font_size.large": "Stor",
    "font_size.extra_large": "Ekstra stor",
    "font_size.xxl": "XXL",
    "font_size.huge": "Kæmpe",
    Now: "Nu",
    "now and share the class activity with your students":
        "nu, og del aktiviteten med dine elever",
    "Number of active learners": "Antal aktive studerende",
    "Number of assignments": "Antal afleveringer",
    "Number of assignments missing feedback":
        "Antal afleveringer som mangler feedback",
    "Number of attempts": "Antal forsøg",
    "Number of decimals": "Antal decimaler",
    "Number of flashcards": "Antal flashkort",
    "Number of lessons": "Antal lektioner",
    "Number of missing": "Antal manglende",
    "Number of questions": "Antal spørgsmål",
    "Number of votes": "Antal stemmer",
    "Number of words": "Antal ord",
    "Number type": "Nummertype",
    "Numeric variables": "Nummeriske variable",
    "Oh no! Something went wrong.": "Åh nej! Noget gik galt.",
    OK: "OK",
    Okay: "Okay",
    Of: "Af",
    of: "af",
    "Of all questions are answered correctly":
        "Af alle spørgsmål bliver korrekt besvaret",
    Off: "Fra",
    "Old password": "Nuværende kodeord",
    "Olly has (finally) finished the task":
        "Olly er (endelig) færdig med opgaven",
    "Olly is working hard to create your content":
        "Olly arbejder hårdt på at oprette dit indhold",
    "Olly will use this to create learning activities from.":
        "Olly vil bruge denne til at lave læringsaktiviteter fra.",
    On: "Til",
    "Only open answer for now": "Kun åbne svar for nu",
    "Only available when the quiz is not a Test": "Kun tilgængelig når quizzen ikke er en test",
    "Oops something went wrong. Maybe you didn't grant permissions to access your camera or microphone.":
        "Ups! Noget gik galt. Tjek at du har givet tilladelse til kamera og mikrofon. ",
    "Oops something went wrong. Please try again.":
        "Ups! Noget gik galt. Prøv igen. ",
    Open: "Åben",
    "Open answer": "Åbent svar",
    "Open external link": "Åben eksternt link",
    "Open link": "Åben link",
    "Open video chat": "Åben video chat",
    "Open turnin": "Åben besvarelse",
    "open-answer": "Åbent svar",
    Option: "Mulighed",
    Optional: "Valgfrit",
    "Optional settings": "Valgfrie indstillinger",
    Options: "Valgmuligheder",
    or: "eller",
    "Or continue using your phone or tablet with limited functionality.":
        "Eller du kan fortsætte med at bruge din telefon eller tablet med begrænset funktionalitet.",
    Orange: "Orange",
    "Order saved": "Rækkefølge gemt",
    Organize: "Organisér",
    Other: "Andet",
    "Other Edaptio products": "Andre Edaptio produkter",
    "Other login options": "Andre loginmuligheder",
    "Other reason": "Anden årsag",
    "Oups! This page does not exist!": "Ups! Denne side eksisterer ikke!",
    Overview: "Overblik",
    "Paid monthly": "Betalt månedligt",
    "Paid yearly": "Betalt årligt",
    Page: "Side",
    Pages: "Sider",
    Participants: "Deltagere",
    Passed: "Bestået",
    "Passed or completed": "Bestået eller fuldført",
    Password: "Kodeord",
    "Password saved": "Kodeord gemt",
    "Passwords must match": "Kodeordene skal være ens",
    "Pass percentage": "Beståelsesprocent",
    "You need {percentage}% correct to pass": "Du skal have {percentage}% rigtige for at bestå",
    "Show the pass percentage to learners": "Vis beståelsesprocenten for kursisterne",
    "Follow the class setting": "Følg holdets indstilling",
    "Always show": "Vis altid",
    "Always hide": "Skjul altid",
    "Quizzes": "Quizzer",
    "Learners see the pass requirement on the front page of every quiz on this class, before they start. A single quiz can override this in its own advanced settings.": "Kursisterne kan se beståelseskravet på forsiden af alle quizzer på dette hold, inden de går i gang. En enkelt quiz kan tilsidesætte dette under sine udvidede indstillinger.",
    "Learners see the requirement on the quiz front page before they start. The class setting decides unless you override it here.": "Kursisterne kan se kravet på quizzens forside, inden de går i gang. Holdets indstilling gælder, medmindre du tilsidesætter den her.",
    "Past consultations": "Tidligere konsultationer",
    "Paste wiris XML": "Indsæt wiris kode",
    Pay: "Betal",
    "Payment details": "Betalingsoplysninger",
    "per active learner": "per aktive studerende",
    "per active learner per month": "per aktive studerende per måned",
    "per month": "per måned",
    "Per month paid yearly": "Per måned betalt årligt",
    Percentage: "Procent",
    "Percentage or fractions": "Procent eller brøk",
    Permission: "Tilladelse",
    Permissions: "Tilladelser",
    "Permission group": "Rolle",
    "Permission groups": "Roller",
    "permissions.view_groups_classes": "Se alle hold og kursisters fremgang uden at kunne ændre noget",
    "permissions.teacher": "Underviserrettigheder: opret og redigér indhold i egne hold",
    "permissions.admin_institution_news": "Administrér nyheder for hele institutionen",
    "permissions.manage_client": "Administrér kunde- og faktureringsoplysninger",
    "permissions.users_group_create_user_directly": "Opret brugere direkte på et hold",
    "permissions.admin_groups_classes":
        "Administrer hold og klasser for hele institutionen",
    "permissions.admin_institution_settings":
        "Administrer generelle instillinger for institutionen",
    "permissions.admin_moodle_administration":
        "Administrer MOODLE for institutionen",
    "permissions.admin_permissions":
        "Administrer tildeling af rettigheder for hele institutionen",
    "permissions.admin_sign_in_as_other": "Log på som anden bruger",
    "permissions.admin_stats": "Tilgå statistikker for hele institutionen",
    "permissions.admin_ums":
        "Administrer UMS/Ludus-synkronisering for institutionen",
    // "permissions.auto_admin_in_groups" : "Automatisk underviser på hold, som brugeren inviteres til",
    "permissions.can_view_teacher_activity": "Kan se underviser-statistikker",
    // "permissions.message_groups_classes" : "Send beskeder til hele hold og klasser",
    // "permissions.search_entire_institution" : "Søg på alle hold, afleveringer og brugere på hele institutionen",
    // "permissions.see_own_assignments" : "Se afleveringer for egen bruger",
    // "permissions.see_own_stats" : "Se statistikker for egen bruger",
    // "permissions.send_reminders" : "Send påmindelser til brugere",
    // "permissions.view_module_assignments" : "Brugerrettigheder til app: afleveringer",
    // "permissions.view_module_conferences" : "Brugerrettigheder til app: Konferencer",
    // "permissions.view_module_file_sharing" : "Brugerrettigheder til app: Fildeling",
    // "permissions.view_module_information" : "Brugerrettigheder til app: Information",
    // "permissions.view_module_quizzes" : "Brugerrettigheder til app: Quizzer",
    // "permissions.view_module_paths" : "Brugerrettigheder til app: Forløb",
    // "permissions.view_module_news" : "Brugerrettigheder til app: Nyheder",
    // "permissions.view_module_materials" : "Brugerrettigheder til app: lektioner",
    // "permissions.view_module_interactive" : "Brugerrettigheder til app: Geogebra",
    // "permissions.view_module_videos" : "Brugerrettigheder til app: Videoer",
    "Personal groups": "Personlige hold",
    "Personal onboarding": "Personlig onboarding",
    Philosophy: "Filosofi",
    Physics: "Fysik",
    "Pick date": "Vælg dato",
    "Pick due date": "Vælg afleveringsdato",
    "Pick due time": "Vælg afleveringstid",
    "Pick from file sharing": "Vælg fra fildeling",
    "Pick new background image": "Vælg nyt baggrundsbillede",
    "Pick time": "Vælg tid",
    "Pick the same date if it is just a single holiday":
        "Vælg den samme dato hvis det er en enkelt helligdag",
    Pin: "Fastgør",
    "Pin post": "Fastgør opslag",
    "Pin side menu": "Fastgør sidemenu",
    pinboard: "opslagstavle",
    Pinboard: "Opslagstavle",
    "Pinboard creation": "Opret opslagstavle",
    "Pinboard edit": "Rediger opslagstavle",
    "Pinboard text": "Opslagstext",
    Pinboards: "Opslagstavler",
    Pink: "Pink",
    Pinned: "Fastgjort",
    Phone: "Telefon",
    Plan: "Plan",
    "Plan will be canceled from the date":
        "Planen vil være opsagt fra den {dato}" /* Translate with param */,
    "Please fix all errors and try again":
        "Venligst ret alle fejl og prøv igen",
    "Please let me finish the previously assigned task before you assign me a new one.":
        "Lad mig venligst afslutte den opgave, jeg tidligere har fået tildelt, før du giver mig en ny opgave.",
    "Please select a user": "Venligst vælg en bruger",
    "Please select the language of the text in order to get the most accurate results":
        "Vælg venligst tekstens sprog for at få de mest præcise resultater",
    "Please select the language you want the generated content in":
        "Vælg venligst det sprog du ønsker det genererede indhold på",
    "Please solve the errors before adding this question":
        "Løs venligst fejlene, før du tilføjer dette spørgsmål",
    "Please use any other browser for browsing our platform.":
        "Venligst brug en hvilken som helst anden browser til at tilgå vores platform.",
    "Verify your email": "Bekræft din email",
    "Please wait until the call owner lets you in":
        "Vent venligst til du bliver lukket ind i opkaldet",
    Polish: "Polsk",
    "Pool size": "Pool størrelse",
    Portuguese: "Portugisisk",
    Possibilities: "Muligheder",
    Post: "Slå op",
    "Post comment": "Kommentér",
    "Post created": "Opslag oprettet",
    "Post removed": "Opslag fjernet",
    "Post saved": "Opslag gemt",
    Practiced: "Trænet",
    "Practice again": "Træn igen",
    "Practice quiz": "Kan træne quiz",
    "Pre-paid active learners number for this plan":
        "Forudbetalt antal aktive studerende for denne plan",
    Premium: "Premium",
    PremiumMonthlyLearnU: "Premium",
    PremiumYearlyLearnU: "Premium",
    Presentation: "Præsentation",
    "Press enter to add new field, and backspace to remove":
        "Tryk enter for at tilføje nyt felt, eller backspace for at slette",
    "Preview data": "Vis data",
    "Preview past feedback": "Vis tidligere feedback",
    "Preview question": "Vis spørgsmål",
    Previous: "Forrige",
    "Previous month": "Forrige måned",
    "Previous topic": "Forrige delemne",
    Proceed: "Fortsæt",
    Profile: "Profil",
    "Profile information": "Profilinformation",
    "Profile information change": "Rediger profilinformation",
    Progress: "Progression",
    Progression: "Progression",
    "Provide more details": "Angiv flere detaljer",
    "Provided email and password do not match. Please try again.":
        "Email og kodeord matcher ikke. Prøv igen.",
    Psychology: "Psykologi",
    "Pull the rows to edit the sort order of the apps and activate/deactivate the app using the lever. You can also hide apps from the students":
        "Træk i ikonerne for at ændre rækkefølgen af apps, og aktiver/deaktiver apps ved at slå den første knap til. Du kan også skjule apps for dine brugere ved at indstille på knappen længst til højre.",
    "Purple": "Lilla",
    "Put labels in the same group to make them interchangeable.":
        "Sæt etiketter i den samme gruppe for at gøre dem udskiftelige.",
    Quarter: "Kvart",
    Question: "Spørgsmål",
    "Question & answers": "Spørgsmål & svar",
    "Question and answers": "Spørgsmål og svar",
    "Question feedback": "Spørgsmålsfeedback",
    "Question title": "Spørgsmålstitel",
    questionnaire: "spørgeskema",
    Questionnaire: "Spørgeskema",
    questionnaires: "Spørgeskemaer",
    Questionnaires: "Spørgeskemaer",
    Questions: "Spørgsmål",
    "Question overview": "Spørgsmålsoversigt",
    "Question statistics": "Spørgsmålsstatistik",
    "Question type": "Spørgsmålstype",
    "Questions in order": "Spørgsmål i rækkefølge",
    "Questions must have at least one correct answer and cannot be empty":
        "Spørgsmål skal have minimum et korrekt svar og må ikke være tomme",
    Queue: "Kø",
    Quiz: "Quiz",
    quiz: "quiz",
    quiz_objects: "Quiz",
    "quiz-question": "quizspørgsmål",
    quiz_question_objects: "Quizspørgsmål",
    "Quiz completion percentage": "Quiz fuldførelsesprocent",
    "Quiz matrix": "Quiz matrix",
    "Quiz mode": "Quiz funktion",
    "Quiz name": "Quiz navn",
    "Quiz question creation": "Opret quizspørgsmål",
    "Quiz question editing": "Redigér quizspørgsmål",
    "Quiz question": "Quizspørgsmål",
    "Quiz questions": "Quizspørgsmål",
    "Quiz statistics": "Quizstatistik",
    "Quiz status": "Quiz status",
    "Quiz title": "Quiz-titel",
    "Quiz type": "Quiz type",
    Quizzes: "Quizzer",
    quizzes: "Quizzer",
    "Quizzes status": "Status på quizzer",
    "Radio buttons": "Radio knapper",
    "raised a hand": "rækker hånden op",
    "Random pool size": "Antal tilfældige spørgsmål",
    "Random questions": "Tilfældige spørgsmål",
    React: "Reaktion",
    "Read messages": "Læste",
    "Read more": "Læs mere",
    "Reading time": "Læsetid",
    "Recalculate assignment plan for user": "Genberegn opgaveplan for bruger",
    "Recalculate assignment plans for group": "Genberegn opgaveplaner for hold",
    "Recalculate cloze options": "Hiv tekst-variable igen",
    Reconnect: "Genopret forbindelse",
    "Refresh board": "Genopfrisk opslagstavle",
    "Refresh the page if the changes do not appear":
        "Genindlæs siden hvis ændringerne ikke kommer frem",
    Register: "Registrér",
    "Register handin": "Registrér aflevering",
    "Register handin manually": "Registrér aflevering manuelt",
    "Register student submission": "Registrer aflevering af studerende",
    Rejected: "Afvist",
    "Reject submission": "Afvis aflevering",
    Released: "Frigivet",
    "Release feedback": "Frigiv feedback",
    "released a course in": "frigav et forløb i",
    "released a lesson in": "frigav en lektion i",
    Religion: "Religion",
    "Remember to link this quiz to a Maple TA assignment after you save it. If you fail to do this, users will encounter a dead link.":
        "Husk at linke denne quiz til en opgave i Maple TA efter du opretter den. Hvis du ikke gør det, vil dine brugere møde et dødt link. ",
    Remove: "Fjern",
    "Remove admin": "Fjern admin",
    "Remove answer": "Fjern svar",
    "Remove assignment": "Fjern opgave",
    "Remove attachment": "Fjern vedhæftet fil",
    "Remove audio": "Fjern lyd",
    "Remove board": "Fjern opslagstavle",
    "Remove collection": "Fjern kollektion",
    "Remove course": "Fjern forløb",
    "Remove external link": "Fjern eksternt link",
    "Remove feedback": "Fjern tilbagemelding",
    "Remove file": "Fjern fil",
    "Remove flashcard": "Fjern flashkort",
    "Remove flashcards": "Fjern flashkort",
    "Remove folder": "Fjern mappe",
    "Remove from Exclusion List": "Fjern fra eksklusionsliste",
    "Remove from material": "Fjern fra lektion",
    "Remove geogebra": "Fjern geogebra",
    "Remove Geogebra element": "Fjern Geogebra element",
    "Remove group": "Fjern hold",
    "Remove image": "Fjern billede",
    "Remove match set": "Fjern match sæt",
    "Remove material": "Fjern lektion",
    "Remove member": "Fjern medlem",
    "Remove label": "Fjern etikette",
    "Remove learning element": "Fjern læringsaktivitet",
    "Remove picture": "Fjern billede",
    "Remove post": "Fjern opslag",
    "Remove subject": "Fjern emne",
    "Remove text": "Fjern tekst",
    "Remove topic": "Fjern underemne",
    "Remove question": "Fjern spørgsmål",
    "Remove questionnaire": "Fjern spørgeskema",
    "Remove quiz": "Fjern quiz",
    "Remove timeline": "Fjern tidslinje",
    "Remove user": "Fjern bruger",
    "Remove user from the conversation": "Fjern bruger fra samtale",
    "Remove vacation/holiday": "Fjern helligdag/ferie",
    "Remove video": "Fjern video",
    "Remove vimeo": "Fjern vimeo",
    "Remove your Facebook account": "Fjern din Facebook bruger",
    "Remove your Google account": "Fjern din Google bruger",
    "Remove youtube": "Fjern youtube",
    "Remove variable": "Fjern variabel",
    "Remove word": "Fjern ord",
    Rename: "Omdøb",
    "Reorder elements": "Omorganiser læringsaktiviteter",
    Repeatable: "Gentagelig",
    "Repeatable quiz": "Gentagelig quiz",
    "Repeat email": "Gentag email",
    "Repeat new password": "Gentag nyt kodeord",
    "Repeat quiz": "Gentag quiz",
    "Repeat password": "Gentag kodeord",
    "Replace picture": "Udskift billede",
    "replied to": "svarede",
    Replies: "Svar",
    "Reply to": "Svar til",
    "Reset password": "Sæt nyt kodeord",
    "Reset completion deadlines": "Genstart gennemførselsdeadlines",
    Required: "Påkrævet",
    "Required pass percentage": "Påkrævet beståelsesprocent",
    "Require attachment": "Krav om vedhæftning",
    "Requires at least": "Kræver mindst",
    Result: "Resultat",
    Results: "Resultater",
    Retry: "Prøv igen",
    "Retry payment": "Prøv at betale igen",
    "Return to dashboard": "Tilbage til dashboard",
    Review: "Gennemgå",
    "Review results": "Gennemgå resultaterne",
    Role: "Rolle",
    Romanian: "Romansk",
    Russian: "Russisk",
    Save: "Gem",
    "Save (discount)": "Spar",
    "Save and attach to feedback": "Gem og vedhæft på feedback",
    "Save and release feedback": "Gem og frigiv feedback",
    "Save and show": "Gem og vis",
    "Save assignment": "Gem opgave",
    "Save audio file": "Gem lydfil",
    "Save changes": "Gem ændringer",
    "Save collection": "Gem kollektion",
    "Interactive content": "Interaktivt indhold",
    "Add interactive content": "Tilføj interaktivt indhold",
    "Edit interactive content": "Rediger interaktivt indhold",
    "Save interactive content": "Gem interaktivt indhold",
    "Upload package": "Upload pakke",
    "Replace package": "Erstat pakke",
    "Processing package\u2026": "Behandler pakke…",
    "Upload a zip of a static HTML site (index.html at the top level), a single HTML file, or a .h5p package": "Upload en zip med et statisk HTML-site (index.html i roden), en enkelt HTML-fil eller en .h5p-pakke",
    "The file could not be read as a zip archive.": "Filen kunne ikke læses som et zip-arkiv.",
    "The package contains too many files (max 2000).": "Pakken indeholder for mange filer (maks. 2000).",
    "The package is too large when unpacked (max 500 MB).": "Pakken er for stor, når den pakkes ud (maks. 500 MB).",
    "The zip must contain an index.html at its top level (or be a valid .h5p package).": "Zip-filen skal indeholde en index.html i roden (eller være en gyldig .h5p-pakke).",
    "This .h5p file does not include its libraries. Export the .h5p with libraries included (e.g. via Lumi) and try again.": "Denne .h5p-fil indeholder ikke sine biblioteker. Eksporter .h5p-filen med biblioteker inkluderet (fx via Lumi) og prøv igen.",
    "The package contains an unsafe file path and was rejected.": "Pakken indeholder en usikker filsti og blev afvist.",
    "Save external link": "Gem eksternt link",
    "Save feedback": "Gem feedback",
    "Save file": "Gem fil",
    "Save flashcards collection": "Gem flashcards",
    "Save geogebra": "Gem geogebra",
    "Save image": "Gem billede",
    "Save in filesystem": "Gem i fildeling",
    "Save order": "Gem rækkefølge",
    "Save question and show": "Gem spørgsmål og vis",
    "Save question": "Gem spørgsmål",
    "Save questionnaire": "Gem spørgeskema",
    "Save quiz": "Gem quiz",
    "Save quiz and show": "Gem quiz og vis",
    "Save video": "Gem video",
    "Save Vimeo video": "Gem Vimeo video",
    "Save payment details": "Gem betalingsoplysninger",
    "Save subject": "Gem emne",
    "Save submission": "Gem aflevering",
    "Save text": "Gem tekst",
    "Save timeline": "Gem tidslinje",
    "Save to": "Gem til",
    "Save to root folder": "Gem i grundfolder",
    "Save topic": "Gem underemne",
    "Save widget": "Gem widget",
    "Save your quiz": "Gem din quiz",
    "Save youtube video": "Gem youtube video",
    Saved: "Gemt",
    Science: "Naturvidenskab",
    School: "Skole",
    Search: "Søg",
    "Search all students": "Søg alle studerende",
    "Search counsellor": "Søg vejleder",
    "Search for users, groups..": "Søg efter hold, brugere..",
    "Search group": "Søg hold",
    "Search Groups to Exclude": "Søg hold at ekskludere",
    "Search members": "Søg medlemmer",
    "Search person": "Søg person",
    "Search question": "Søg spørgsmål",
    "Search results": "Søgeresultater",
    "Search student": "Søg studerende",
    "Search students in the class": "Søg kun studerende på hold",
    "Search user": "Søg bruger",
    "Search for a user": "Søg efter en bruger",
    "Use the search field above to find users": "Brug søgefeltet ovenfor for at finde brugere",
    "Search youtube": "Søg Youtube",
    sec: "sek",
    "Security warning": "Sikkerhedsadvarsel",
    "See all": "Se alle",
    "See all news": "Se alle nyheder",
    "See past feedback": "Se tidligere feedback",
    "See members on plan": "Se medlemmer på plan",
    "See your feedback below": "Se din feedback nedenfor",
    Seen: "Set",
    "Seen by all": "Set af alle",
    "Seen by student": "Set af studerende",
    "Select a folder": "Vælg en folder",
    "Select a media type that you want to create":
        "Vælg hvilket medie du gerne vil oprette",
    "Select a month": "Vælg en måned",
    "Select a question type": "Vælg en spørgsmålstype",
    "Select a widget type you want to add":
        "Vælg den type widget du gerne vil tilføje",
    "Select a year": "Vælg et år",
    "Select activity type": "Vælg aktivitetstype",
    "Select attachments": "Vælg filer",
    "Select file type": "Vælg filtyper",
    "Select from list": "Vælg fra liste",
    "Select submission type": "Vælg afleveringstype",
    "Select subscription": "Vælg plan",
    "Select plan": "Vælg plan",
    "Select tags": "Vælg emner",
    "Select the language of the source": "Vælg kildens sprog",
    "Select the language for the results": "Vælg sprog for resultaterne",
    "Select the language of the text source": "Vælg tekstens sprog",
    "Select the learning activities you want to create from the text":
        "Vælg de læringsaktiviteter, du ønsker at oprette ud fra teksten",
    "Selected class": "Valgte hold",
    "Selected user": "Valgte bruger",
    "Selected counsellor's students": "Valgte vejleders studerende",
    "Selected Group": "Valgte Hold",
    "Selected groups": "Valgte hold",
    "Select a group to view details": "Vælg et hold for at se detaljer",
    "Selected members": "Valgte medlemmer",
    Send: "Send",
    "Send a message to start the chat": "Send en besked for at starte chatten",
    "Send copy to colleagues": "Send kopi til kolleger",
    "Send element to these colleagues?": "Send element til disse kolleger?",
    "Send element to this colleague?": "Send element til denne kollega?",
    "Send Invites": "Send invitationer",
    "Send message": "Send besked",
    "Send messages": "Send beskeder",
    "Send new password": "Send nyt kodeord",
    "Send notification to all students in this group about this course release?": "Send notifikation til alle elever i denne gruppe om forløbsudgivelsen?",
    "Send notification to all students in this group about this lesson release?": "Send notifikation til alle elever i denne gruppe om lektionsudgivelsen?",
    "Send unreleased feedback": "Send ikke-frigivet feedback",
    Sentence: "Sætning",
    Serbian: "Serbisk",
    "Serbo-Croatian": "Serbo-kroatisk",
    "Set or change an individual due date":
        "Indstil eller rediger en individuel afleveringsdato",
    Setting: "Indstilling",
    Settings: "Indstillinger",
    "Settings saved": "Indstillinger gemt",
    Setup: "Opsætning",
    "Sign up": "Tilmeld dig",
    "Sign up as user type":
        "Opret bruger som {userType}" /* Translate with param */,
    "Sign up with email": "Tilmeld dig med email",
    "Sign up with Facebook": "Tilmeld dig med Facebook",
    "Sign up with Google": "Tilmeld dig med Google",
    "Sign up with Microsoft": "Tilmeld dig med Microsoft",
    "Simplemath settings": "Simplemath indstillinger",
    Size: "Størrelse",
    Share: "Del",
    "Share class": "Del hold",
    "Share course": "Del forløb",
    "Share element": "Del element",
    "Share file": "Del fil",
    "Share folder": "Del mappe",
    "Share material": "Del lektion",
    "Share screen": "Del skærm",
    "Share with colleagues": "Del med kolleger",
    shared: "Delt",
    "shared the assignment": "Delte opgaven",
    "shared the course": "Delte forløbet",
    "shared the flashcard": "Delte flashkortet",
    "shared the flashcard collection": "Delte flashkort kollektionen",
    "shared the folder": "Delte folderen",
    "shared the geogebra": "Delte geogebra aktiviteten",
    "shared the group": "Delte holdet",
    "shared the lesson": "Delte lektionen",
    "shared the link": "Delte linket",
    "shared the media": "Delte mediaet",
    "shared the text": "Delte teksten",
    "shared the question": "Delte spørgsmålet",
    "shared the questionnaire": "Delte spørgsskemaet",
    "shared the quiz": "Delte quizzen",
    "shared the timeline": "Delte tidslinjen",
    "Shared with me": "Delt med mig",
    "Short answer": "Kortsvar",
    "Short answer settings": "Kortsvarindstillinger",
    "short-answer": "Kortsvar",
    "short-answer-wiris": "Wiris kortsvar",
    Show: "Vis",
    "Show all": "Vis alle",
    "Show element": "Vis aktivitet",
    "Show info": "Vis info",
    "Show less": "Vis mindre",
    "Show more": "Vis mere",
    "Skip first line": "Spring første linje over",
    "Skip over elements that have already been copied":
        "Spring aktiviteter over som allerede er blevet kopieret",
    Slovak: "Slovakisk",
    Socialstudies: "Samfundsfag",
    "Some elements have already been copied to these groups.":
        "Nogle aktiviteter er allerede blevet kopieret til disse hold",
    "Some elements have already been copied to this group.":
        "Nogle aktiviteter er allerede blevet kopieret til dette hold",
    "Some of the questions failed to be copied":
        "Nogle af spørgsmålene blev ikke kopieret",
    "Sorry, we can not connect your account. Please try again later.":
        "Beklager, vi kan ikke linke din bruger på dette tidspunkt. Prøv venligst senere.",
    "Sorry, but you do not have permission to access this page":
        "Beklager, men du har ikke tilladelse til at tilgå denne side.",
    "Sorry to see you go": "Ked af at se dig gå",
    Source: "Kilde",
    "Source successfully uploaded": "Teksten er gemt og klar",
    Spanish: "Spansk",
    "Spanish Latin American": "Spansk (Latin Amerika)",
    Speakers: "Højtalere",
    "Specify the difficulty of the question. This is your subjective assessment compared to the rest of the content.":
        "Sæt sværhedsgraden på dette spørgsmål. Dette er din subjektive vurdering sammenlignet med resten af indholdet på dette niveau.",
    Spell: "Stav",
    "spell-speech": "Stav ord",
    "Spell word": "Stav ord",
    Standard: "Standard",
    StandardMonthlyLearnU: "Standard",
    StandardYearlyLearnU: "Standard",
    "Standard DPA": "Standard DPA",
    Start: "Start",
    "Start broadcasting": "Begynd at udsende video",
    "Start by building your content with courses":
        "Start med forløb til at bygge din læringsstruktur",
    "Start by adding learning elements listed on the left by pressing a plus button or dragging and dropping them below.":
        "Start med at tilføje læringsaktiviteter fra listen til venstre ved at klikke på plusset, eller trække dem ind hvor du gerne vil placere dem. ",
    "Start exam mode": "Start eksamenstilstand",
    "Start making great learning content, by verifying your email.":
        "Verificer din email, og begynd at bygge fantastiske læringsmaterialer!",
    "Start new discussion": "Start ny debat",
    "Start quiz": "Start quiz",
    "Start reading": "Start oplæsning",
    "Start video chat": "Start video chat",
    Statistics: "Statistik",
    Status: "Status",
    "STEM questions": "STEM spørgsmål",
    "Stop broadcasting": "Stop videoudsendelse",
    "Stop exam mode": "Stop eksamenstilstand",
    "Stop reading": "Stop oplæsning",
    "Stop sharing": "Stop deling",
    "Structure course content using lessons":
        "Strukturer dit læringsindhold med lektioner",
    Student: "Studerende",
    student: "studerende",
    "Student submission registered by teacher":
        "Studerendes aflevering registreret af underviser",
    students: "studerende",
    Students: "Studerende",
    "Student administration": "Administration",
    "Student handed in offline":
        "Opgaveaflevering registreret manuelt af underviser",
    "Student has not handed in this submission yet.":
        "Brugeren har ikke afleveret denne afleveringsopgave endnu.",
    "Student hours": "Elevtimer",
    "Student hours help indicate to your students how much time they should spend on the submission":
        "Elevtimer hjælper dine studerende med at indikere hvor meget tid de skal bruge på en aflevering",
    "Student is not part of any class yet":
        "Brugeren er ikke medlem af nogen hold endnu",
    "Students can add flashcards": "Studerende kan tilføje flashkort",
    "Students can see results": "Brugere kan se resultater",
    "Students have been notified about the course release": "Eleverne er blevet underrettet om forløbet er frigivet",
    "Students have been notified about the lesson release": "Eleverne er blevet underrettet om lektionen er frigivet",
    "Students list": "Studerende liste",
    "Student / student average": "Bruger / gennemsnit af bruger",
    "Student Testing": "Studerende test",
    "Student submission will be registered when the feedback is saved":
        "Studerendes aflevering vil blive registreret, når feedbacken gemmes",
    "Student view": "Brugervisning",
    Subgroups: "Underhold",
    Subject: "Emne",
    Subjects: "Emner",
    Submission: "Aflevering",
    submission: "aflevering",
    "Submission example": "Afleveringseksempel",
    "Submission creation": "Afleveringsoprettelse",
    "Submission information": "Afleveringsinformation",
    "Submission missing feedback": "Afleveringer som mangler feedback",
    "Submission plan": "Afleveringsplan",
    "Submission title": "Afleveringstitel",
    "Submission type": "Afleveringstype",
    Submissions: "Afleveringer",
    "Submissions awaiting feedback": "Afleveringer der mangler feedback",
    "Show": "Vis",
    "All": "Alle",
    "Showing": "Viser",
    "See all submissions": "Se alle afleveringer",
    "Search by student or submission": "Søg på kursist eller aflevering",
    "All classes": "Alle hold",
    "No submissions are awaiting feedback. Nice work!": "Der er ingen afleveringer, der mangler feedback. Godt gået!",
    "No submissions match your filters.": "Ingen afleveringer matcher dine filtre.",
    "By assignment": "Fordelt på aflevering",
    "By student": "Fordelt på kursist",
    "Open assignment": "Åbn afleveringen",
    Showing: "Viser",
    "per page": "pr. side",
    "1 day waiting": "1 dag i kø",
    "{days} days waiting": "{days} dage i kø",
    Submit: "Indsend",
    "Submit answer & continue": "Angiv svar & fortsæt",
    "Submit questionnaire": "Aflevér spørgeskema",
    Submitted: "Afleveret",
    Subscription: "Abonnement",
    "Subscription type": "Abonnementstype",
    Success: "Succes",
    "Support mail": "Support e-mail",
    "Sure, lets go!": "Klart, lad os fortsætte!",
    Surname: "Efternavn",
    Swahili: "Swahili",
    "Swap out": "Udskift",
    Swedish: "Svensk",
    Switch: "Udskift",
    "Switch additional group": "Udskift sekundært hold",
    "Switch back to main user": "Skift tilbage til oprindelige bruger",
    "Switch devices now to start adding learning activities into your lessons.":
        "Skift enheder nu for at begynde at tilføje læringsaktiviteter i dine lektioner.",
    "Switch main group": "Udskift primært hold",
    "Switch to add these activities:":
        "Skift for at tilføje disse aktiviteter:",
    Sync: "Synkronisér",
    "Synchronize elements that have already been copied":
        "Synkronisér aktiviteter som allerede er blevet kopieret",
    "Synchronize hashtags manually": "Synkronisér hashtags manuelt",
    Tags: "Emner",
    Tamil: "Tamil",
    teacher: "underviser",
    Teacher: "Underviser",
    "Teacher view": "Vis som underviser",
    Teachers: "Undervisere",
    "Teachers on plan": "Undervisere på planen",
    Term: "Udtryk",
    "Terms & definitions": "Termer & definitioner",
    "Terms and Conditions": "Brugsbetingelser",
    Test: "Test",
    "Test answer": "Test svar",
    text: "Tekst",
    Text: "Tekst",
    "Text can't be empty and should be shorter then 255 characters.":
        "Tekst kan ikke være tom og skal være mindre end 255 karakterer.",
    "Text copied": "Tekst kopieret",
    "Text on label": "Tekst på etikette",
    "Text title": "Tekst titel",
    Time: "Tid",
    timeline: "tidslinje",
    Timeline: "Tidslinje",
    "Time in HH:MM:SS": "Tid i TT:MM:SS",
    "Time to complete course (days)": "Tid til at gennemføre holdet (dage)",
    Timelines: "Tidslinjer",
    Timestamp: "Tidsstempel",
    Tip: "Tip",
    Title: "Titel",
    "Title required": "Titel er påkrævet",
    "Title too long": "Titel for lang",
    Thai: "Thailandsk",
    "Thanks for your answer": "Tak for dit svar",
    "Thank you for your interest in Edaptio.":
        "Tak for din interesse i Edaptio.",
    "Thank you for your understanding": "Tak for din forståelse",
    "That was all I got for you this time":
        "Det var alt, hvad jeg havde til dig denne gang",
    "The amount of random questions each learner receives":
        "Antallet af tilfældige spørgsmål, som hver lærende modtager",
    "The assignment is closed for handin": "Opgaven er lukket for aflevering",
    "The call owner denied your request to join":
        "Ejeren af videokaldet afviste din anmodning om at joine",
    "The corrections have been attached to the feedback":
        "Retterelserne er vedhæftet din tilbagemelding",
    "The elements have been added to the existing learning activity":
        "Elementerne er blevet tilføjet til den eksisterende læringsaktivitet",
    "The Geogebra element has been created":
        "Geogebra aktiviteten blev oprettet",
    "The Geogebra element has been saved": "Geogebra aktiviteten blev gemt",
    "The group is currently in exam mode. All communication suspended.":
        "Holdet er i øjeblikket i eksamenstilstand. Al kommunikation er suspenderet.",
    "The question has been created": "Spørgsmålet blev oprettet",
    "The question has been saved": "Spørgsmålet blev gemt",
    "The quiz has been created": "Quizzen blev oprettet",
    "The quiz has been saved": "Quizzen blev gemt",
    "The message was succesfully deleted": "Besked er nu slettet",
    "The price is too high": "Prisen er for høj",
    "The system cannot auto-correct open answer questions, but your teacher can see your answer.":
        "Systemet kan ikke automatisk rette åbne spørgsmål, men din underviser kan se dit svar.",
    "The system rejected the request with the following message":
        "Systemet afviste operationen med følgende besked",
    "The user has received an email with all the necessary information to get started":
        "Brugeren har modtaget en mail med alle de relevante informationer til at komme i gang.",
    "The user will write an open ended text here":
        "Brugeren vil skrive et åbent svar her",
    "There are no answers posted. Add a first answer to this post.":
        "Der er ingen svar på dette opslag endnu. Vær den første til at svare.",
    "There are no existing data to display. Start by creating one direct":
        "Der er ikke nogen {name} at vise. Du kan oprette en ny i sidemenuen",
    "There are no items to display": "Der er intet at vise her",
    "There are no learning elements in this category to display. Start by creating one":
        "Der er ingen læringsaktiviteter at vise i denne kategori. Start med at oprette et!",
    "There are no lessons to display. Start by creating one":
        "Ingen lektioner fundet. Start med at oprette en",
    "There are no consultations created. Start by creating one":
        "Du har ikke oprettet en konsultation endnu. Start ved at oprette en",
    "There are no submissions to display. Start by creating one":
        "Der er ingen afleveringer at vise. Start med at oprette en ny",
    "There are unsaved changes": "Der er ændringer som ikke er gemt",
    "There is currently an error with the WIRIS plugin, which is why we have removed it. We are working on resolving it.":
        "Der er i øjeblikket en fejl med WIRIS pluginet, og vi har fjernet det. Vi arbejder hårdt på at få det løst.",
    "This course is a reference from another group, and can therefore not be edited here.":
        "Dette forløb er en reference til et andet sted, og kan derfor ikke rettes her.",
    "This course is depending on the other courses. Students can not start it until they complete the other.":
        "Dette forløb er afhængigt af andre forløb. Brugere kan ikke starte dette forløb før de færddiggør de andre forløb.",
    "This course has been copied to this group before.":
        "Dette forløb er blevet kopieret til dette hold før.",
    "This element has been copied to this group before.":
        "Dette element er blevet kopieret til dette hold før.",
    "This lesson has been copied to this group before.":
        "Denne lektion er blevet kopieret til dette hold før.",
    "This group does not have a class notebook yet. Contact your teacher in order to fix this.":
        "Dette hold har ikke en klassenotesbog endnu. Kontakt din underviser for at fikse det.",
    "this guide": "denne guide",
    "This is a beta feature, and errors can occur":
        "Dette er en eksperimentel funktion, og fejl kan opstå.",
    "This is a collection of all the videos from your courses":
        "Dette er en samling af alle videoerne fra dine forløb",
    "This is the number of learners not covered in your pre-paid plan. These will be charged separately according to our pricing plan.":
        "Dette er antallet af brugere uden for din forudbetalte plan. Dette antal bliver faktureret seperat ud fra vores pristabel.",
    "This is an open answer question. This means that you have to reflect on the question, and you have to write an answer to complete it.":
        "Dette er et 'åbent svar' spørgsmål. Det betyder, at du skal reflektere og svare med dine egne ord, og du skal skrive noget for at fuldføre det.",
    "This is an overview of the students progression through the videos in the courses/materials.":
        "Dette er et overblik over brugerens progression igennem videoerne i forløbene/lektionerne.",
    "This lesson is a reference from another group, and can therefore not be edited here.":
        "Denne lektion er en reference til et andet sted, og kan derfor ikke rettes her.",
    "This lesson is empty.": "Denne lektion er tom.",
    "This message was deleted": "Besked er nu slettet",
    "This object is empty": "{name} er tom" /* Translate with param */,
    "This quiz type requires an active subscription to Maple TA, which you need to obtain yourself.":
        "Denne quiztype kræver en aktiv licens til Maple TA's software, som du selv/din institution står for at anskaffe.",
    "This widget imports all of your courses automatically":
        "Denne widget importerer automatisk alle dine forløb i rækkefølge",
    "This will hold news from your classes":
        "Her vil der komme nyheder på tværs af dine hold",
    "This will except the user for any assignments in that period. The effect is immediate.": "Dette vil fritage brugeren for alle opgaver i den pågældende periode. Effekten er øjeblikkelig.",
    "Three quarter": "Trekvart",
    to: "til",
    To: "Til",
    Today: "Idag",
    "Toggle fullscreen mode": "Gå til fuldskærm",
    Top: "Top",
    Topic: "Underemne",
    Topics: "Underemner",
    "to join your class.": "for at tilmelde sig holdet",
    "To top": "Til top",
    Total: "Total",
    "Toggle fullscreen": "Skift fuldskærm",
    "Total number of assignment turnins": "Samlet antal af opgavebesvarelser",
    Trainable: "Muligt at træne",
    "Train mathematics": "Træn matematik",
    Translate: "Oversæt",
    "Translate word": "Oversæt ord",
    Tries: "Forsøg",
    Try: "Forsøg",
    "Try again": "Prøv igen",
    "Try Edaptio": "Prøv Edaptio",
    "Try now": "Prøv nu",
    "Try to adjust the text": "Prøv at justere din tekst",
    Turkish: "Tyrkisk",
    "Turnin overview": "Afleveringsoversigt",
    "Turn in quiz": "Aflever quiz",
    "Turn on/off exam mode": "Slå eksamenstilstand til/fra",
    "Turn video off": "Slå video fra",
    "Turn video on": "Slå video til",
    Type: "Type",
    "Type in a definition": "Indsæt definition",
    "Type in a question": "Skriv et spørgsmål",
    "Type in a term": "Indsæt udtryk",
    "Type in an answer": "Skriv et svar",
    "Type in your comment": "Skriv din kommentar",
    "Type in your message": "Skriv besked her",
    "Type of billing": "Faktureringstype",
    "Type something": "Skriv noget",
    "UK English": "Engelsk (UK)",
    UMS: "UMS",
    "UMS group": "UMS hold",
    "UMS/LUDUS": "UMS/LUDUS",
    "Enable students dropouts from UMS": "Aktivér elevudmeldinger fra UMS",
    "Clean up a class against UMS/Ludus": "Ryd op i et hold ud fra UMS/Ludus",
    "Find the class, see who is enrolled in Edaptio but no longer on the hold in UMS/Ludus, and move them to dropped-out students.": "Find holdet, se hvem der står i Edaptio, men ikke længere står på holdet i UMS/Ludus, og ryk dem ned til udmeldte kursister.",
    "Search for a class": "Søg efter et hold",
    "e.g. 4F11D or Dansk": "f.eks. 4F11D eller Dansk",
    "Search": "Søg",
    "No classes found": "Ingen hold fundet",
    "Check class": "Tjek holdet",
    "Edaptio": "Edaptio",
    "UMS": "UMS",
    "{count} more matching classes are hidden because UMS/Ludus is not describing them right now.": "{count} hold mere matcher, men er skjult, fordi UMS/Ludus ikke beskriver dem lige nu.",
    "Ends": "Slutter",
    "Reading UMS/Ludus...": "Læser fra UMS/Ludus...",
    "Matching students": "Kursister der passer",
    "in UMS/Ludus": "i UMS/Ludus",
    "This class already matches UMS/Ludus. Nothing to do.": "Holdet passer allerede med UMS/Ludus. Der er ikke noget at rette.",
    "In Edaptio, but not on the hold in UMS/Ludus": "Står i Edaptio, men ikke på holdet i UMS/Ludus",
    "These will be moved to dropped-out students. They keep their work and can be added back.": "Disse rykkes ned til udmeldte kursister. De beholder deres arbejde og kan tilføjes igen.",
    "On the hold in UMS/Ludus, but not in Edaptio": "Står på holdet i UMS/Ludus, men ikke i Edaptio",
    "These will be enrolled in the class.": "Disse bliver tilmeldt holdet.",
    "Refresh from UMS/Ludus": "Hent igen fra UMS/Ludus",
    "Update class": "Opdatér holdet",
    "Could not read UMS/Ludus right now. Try again shortly.": "Kunne ikke læse fra UMS/Ludus lige nu. Prøv igen om lidt.",
    "Could not update the class right now. Try again shortly.": "Kunne ikke opdatere holdet lige nu. Prøv igen om lidt.",
    "From UMS/Ludus": "Fra UMS/Ludus",
    "From Moodle": "Fra Moodle",
    "Added manually": "Tilføjet manuelt",
    "Added via invitation": "Tilføjet via invitation",
    "Joined with a code": "Tilmeldt med kode",
    "Added automatically": "Tilføjet automatisk",
    "Unknown origin": "Ukendt oprindelse",
    "Class updated": "Holdet er opdateret",
    "moved to dropped-out students": "rykket ned til udmeldte kursister",
    "enrolled": "tilmeldt",
    Unarchive: "Fjern fra arkiv",
    "Unarchive group": "Fjern hold fra arkiv",
    "Unarchive for all": "Fjern fra arkiv for alle",
    "Unarchive for you": "Fjern fra arkiv for kun dig",
    Unassign: "Fjern tildeling",
    "Unilogin username": "Unilogin brugernavn",
    Unknown: "Ukendt",
    "Unlimited active learners": "Ubegrænset antal aktive brugere",
    "Unlimited classes, courses & lessons":
        "Ubegrænset hold, forløb og lektioner",
    "Unlimited co-teachers": "Ubegrænset antal medundervisere",
    "Unlimited storage": "Ubegrænset lagerplads",
    "Unlock board": "Lås opslagstavle op",
    "Unlock board item": "Lås opslag op",
    Unmute: "Slå lyd til",
    Unmuted: "Mic på",
    Unpin: "Frigør",
    "Unpin post": "Frigør opslag",
    "Unpin side menu": "Gør sidemenu flydende",
    "Unread messages": "Ulæste",
    Unsubscribe: "Opsig",
    "Up to 100 active learners": "Op til 100 aktive studerende",
    "Up to 250 active learners": "Op til 250 aktive studerende",
    "Upcoming consultations": "Kommende konsultationer",
    "Update profile picture": "Opdater profilbillede",
    "Update and log in": "Opdatér og log in",
    "updated the assignment": "opdaterede afleveringen",
    Upgrade: "Opgrader",
    "Upgrade plan": "Opgrader",
    "Upgrade your plan": "Opgrader din plan",
    "Upgrade your plan to increase the storage space":
        "Opgrader dit abonnement for at få mere lagerplads",
    Upload: "Upload",
    "Upload an example submission that yours students will see after they receive your feedback for the submission":
        "Upload et eksempel på en besvarelse, som dine elever automatisk kan se efter du har givet feedback",
    "Upload feedback": "Upload feedback",
    "Upload failed": "Upload mislykkedes",
    "Upload new file": "Upload ny fil",
    Uploads: "Uploaded",
    "Upper border": "Øvre grænse",
    "Use 0 if you want to disable it":
        "Brug 0 hvis du vil slå beståelsesprocent fra",
    "Use in group": "Brug på hold",
    "Use course in group": "Brug forløb på hold",
    "Use hashtags before the words in the text that need to be filled in.":
        "Brug hashtags {insertion} før de ord i teksten, der skal udfyldes." /* Translate with param */,
    "Use hashtags to indicate word insertions":
        "Brug hashtags til at oprette felter til indsættelse af ord.",
    "Use learning element in group": "Brug læringsobjekt på hold",
    "Use lessons to divide your courses into smaller bites, that are easier for users to digest. Lessons are packages of learning elements that provide context to the learning the user has to obtain.":
        "Brug lektioner til at inddele dine forløb i mindre, mere spiselige bidder. Lektioner er pakker af læringslemeneter, som giver kontekst til den læring som brugeren skal igennem.",
    "Use material in group": "Brug lektion på hold",
    "Use the arrow keys to switch and flip the cards":
        "Brug pilepasterne på tastaturet til at skifte- og vende flashkort",
    "Use the feedback, improve your assignment and hand in again":
        "Brug feedbacken, finpuds opgaven og aflever igen.",
    "Use this in a group": "Brug dette på et hold",
    User: "Bruger",
    "User assignments behind": "Brugere som er bagud med afleveringer",
    "User assignment progression throughout courses":
        "Brugerprogression i afleveringer opdelt i forløb",
    "User created": "Bruger oprettet",
    "This user already exists": "Brugeren findes allerede",
    "Add to institution": "Tilføj til institutionen",
    "already has an Edaptio account that is not attached to this institution. Add the existing user instead of creating a new one?":
        "har allerede en Edaptio-bruger, som ikke er tilknyttet denne institution. Vil du tilføje den eksisterende bruger i stedet for at oprette en ny?",
    "User added to the institution": "Brugeren er tilføjet institutionen",
    "User added. Send them a new password to let them log in":
        "Brugeren er tilføjet. Send et nyt kodeord, så vedkommende kan logge ind",
    "User not found": "Brugeren blev ikke fundet",
    "User is already in this institution": "Brugeren er allerede tilknyttet denne institution",
    "User creation": "Brugeroprettelse",
    "User is presented with a single random word":
        "Brugeren bliver præsenteret med et enkelt tilfældigt ord",
    "User is presented with all words":
        "Brugeren bliver præsenteret med alle ord fra listen",
    "User name": "Brugernavn",
    "User progression": "Brugerprogression",
    "User quiz progression": "Brugerprogression i quizzer",
    "User deleted": "Bruger slettet",
    "User saved": "Bruger gemt",
    "User was removed from conversation":
        "{user_name} blev fjernet fra samtalen {conversation_name}" /* Translate with params like in en_US file */,
    Users: "Brugere",
    "Admin Users": "Administratorbrugere",
    "View Admin Users": "Se administratorbrugere",
    "User ID": "Bruger-ID",
    "View users by permission group": "Se brugere efter rolle",
    "Select Permission Group": "Vælg rolle",
    "Choose a permission group...": "Vælg en rolle...",
    "Please select a permission group": "Vælg venligst en rolle",
    "Choose a permission group from the dropdown above to view its members": "Vælg en rolle fra dropdown-menuen ovenfor for at se dens medlemmer",
    "Total members": "Antal medlemmer",
    "No users found in this permission group": "Ingen brugere fundet i denne rolle",
    "Move to Permission Group": "Flyt til rolle",
    "Inactive User": "Inaktiv bruger",
    "Permission group updated successfully": "Rolle opdateret succesfuldt",
    "Failed to update permission group": "Kunne ikke opdatere rolle",
    "Failed to load admin users": "Kunne ikke indlæse administratorbrugere",
    "Failed to load permission groups": "Kunne ikke indlæse roller",
    "Merge users": "Flet brugere",
    "Merge User Accounts": "Flet brugerkonti",
    "Target User (Keep this account)": "Målbruger (Behold denne konto)",
    "This user will be kept": "Denne bruger vil blive beholdt",
    "Source User (Merge and delete this account)": "Kildebruger (Flet og slet denne konto)",
    "This user will be deleted": "Denne bruger vil blive slettet",
    "Search target user": "Søg målbruger",
    "Search source user": "Søg kildebruger",
    "Clear selection": "Ryd valg",
    "Continue to Confirmation": "Fortsæt til bekræftelse",
    "Warning: This action cannot be undone!": "Advarsel: Denne handling kan ikke fortrydes!",
    "Warning: Submissions without an attached file may be rejected by the teacher.": "Advarsel: Afleveringer uden en vedhæftet fil kan blive afvist af læreren.",
    "All data from the source user will be permanently transferred to the target user.": "Alle data fra kildebrugeren vil blive permanent overført til målbrugeren.",
    "This includes: activity logs, quiz responses, group memberships, assignments, messages, files, and all other user data.": "Dette inkluderer: aktivitetslogfiler, quizsvar, gruppemedlemskaber, opgaver, beskeder, filer og alle andre brugerdata.",
    "Review merge details:": "Gennemgå flette-detaljer:",
    "Keep this user": "Behold denne bruger",
    "Delete this user": "Slet denne bruger",
    "I understand this action is permanent and cannot be reversed": "Jeg forstår, at denne handling er permanent og ikke kan omgøres",
    "Merge Users": "Flet brugere",
    "Cannot merge a user with themselves": "Kan ikke flette en bruger med sig selv",
    "Users merged successfully": "Brugere flettet succesfuldt",
    "An error occurred during merge": "Der opstod en fejl under fletning",
    "Users must belong to the same institution": "Brugerne skal tilhøre den samme institution",
    "You can only merge accounts that both belong to an institution you administer.": "Du kan kun flette konti, der begge tilhører en institution, du administrerer.",
    "Source user is already merged": "Kildebrugeren er allerede flettet",
    "Target user does not exist": "Modtagerbrugeren findes ikke",
    "Source user does not exist": "Kildebrugeren findes ikke",
    "Merge failed due to database errors. Check debug info for details.": "Fletningen mislykkedes på grund af databasefejl.",
    "Users not yet started": "Brugere som ikke er startet endnu",
    "Users under average completion":
        "Brugere der ligger under gennemsnittet for holdet",
    Username: "Brugernavn",
    "US English": "Engelsk (US)",
    Validating: "Validerer",
    Value: "Værdi",
    "video-conference": "Videohjælp",
    Video: "Video",
    "No video room available for this consultation": "Intet videoopkaldsrum tilgængeligt for denne konsultation",
    "Video call error": "Fejl i videoopkald",
    "Video chat": "Video chat",
    "Video chat does not exist or it's already finished.":
        "Video chatten kunne ikke findes.",
    "Video conferencing & messaging": "Videokonferencer og beskeder",
    "Video ID/link": "Video ID/link",
    "Video id required": "Video id påkrævet",
    "Video is off": "Video slukket",
    "Video is on": "Video tændt",
    videos: "Videoer",
    "Video preview": "Video forhåndsvisning",
    "Video quiz": "Video quiz",
    Vietnamese: "Vietnamesisk",
    View: "Vis",
    "Viewing as a student": "Viser som en studerende",
    "Viewing as a teacher": "Viser som en underviser",
    "View messages": "Vis meddelelser ",
    Vimeo: "Vimeo",
    "Vimeo video ID/Link": "Vimeo video ID/Link",
    "Visible to students": "Synlig for brugere",
    "Visual arts": "Billedkunst",
    "Voice gender": "Køn på stemme",
    "wants to join": "vil gerne ind",
    "wants to join video chat": "vil gerne deltage i video chat",
    webinars: "webinar",
    weekdays: {
        Sunday: "Søndag",
        Monday: "Mandag",
        Tuesday: "Tirsdag",
        Wednesday: "Onsdag",
        Thursday: "Torsdag",
        Friday: "Fredag",
        Saturday: "Lørdag"
    },
    "Weekdays-full-array": [
        "Søndag",
        "Mandag",
        "Tirsdag",
        "Onsdag",
        "Torsdag",
        "Fredag",
        "Lørdag"
    ],
    "Weekdays-short-array": ["Søn", "Man", "Tirs", "Ons", "Tors", "Fre", "Lør"],
    Welsh: "Walisisk",
    "We are preparing your file for embed, make sure to refresh the page in a little while. This should take no more than 2 minutes.":
        "Vi er ved at forberede din fil til indlejring. Genindlæs siden om et lille stykke tid for at se resultatet. Dette bør ikke tage mere end 2 minutter.",
    "We can not find any data to display. Wait for your teacher to add some.":
        "Vi kan ikke finde nogen {insertion} at vise. Vent på at underviseren tilføjer det." /* Translate with param like in en_US file */,
    "We can not find any data to display. Wait for your teacher to create submission.":
        "Vi kan ikke finde nogen {insertion} at vise. Vent på at din underviser tilføjer det." /* Translate with param like in en_US file */,
    "We can not find any data to display. Wait for your teacher to upload some.":
        "Vi kan ikke finde nogen {insertion} at vise. Vent på at underviseren uploader det." /* Translate with param like in en_US file */,
    "We can not find any lesson in course. Wait for your teacher to add some.":
        "Vi kan ikke finde nogen lektioner i '{insertion}' forløbet. Vent på at din underviser opretter dem." /* Translate with param */,
    "We can see, that you are using Internet Explorer to browse the web. This is an old, outdated and insecure browser, which is why we have chosen not to support it.":
        "Vi kan se, at du bruger Internet Explorer til at gå på internettet. Dette er en gammel og usikker browser, som vi har valgt ikke længere at supportere. ",
    "We have sent an email to the provided email address, if it exists in the system. Remember to check your spam filter.":
        "Vi har sendt en email til mail adressen hvis de eksisterer i vores system. Husk at tjekke dit spam filter.",
    "We have sent you a temporary password via email":
        "Vi har sendt dig et midlertidigt kodeord via email",
    "We sent a verification link to":
        "Vi har sendt et bekræftelseslink til {email}",
    "Welcome to": "Velkommen til",
    "What are you?": "Hvad er du?",
    "What do you want to create?": "Hvad ønsker du at skabe?",
    "What educational level?": "Hvilket klassetrin?",
    "What media should the users turn in?":
        "Hvilken type medie skal afleveres?",
    "What skills level?": "Hvilket niveau?",
    "What type of assignment?": "Hvilken type opgave?",
    "What would you like to learn about?": "Hvad vil du gerne lære om?",
    "When is the assignment due?": "Hvornår skal opgaven afleveres?",
    "When on, a learner who answers a question incorrectly can retry that single question instead of repeating the whole quiz.": "Når slået til kan en elev, der svarer forkert på et spørgsmål, prøve netop det spørgsmål igen i stedet for at gentage hele quizzen.",
    "When enabled, students must attach a file. Text-only submissions will not be accepted.": "Når aktiveret, skal eleverne vedhæfte en fil. Rene tekstindleveringer accepteres ikke.",
    "Who are you?": "Hvem er du?",
    "WIRIS match": "WIRIS match",
    "WIRIS multiple choice": "WIRIS multiple choice",
    "WIRIS short answer": "WIRIS kortsvar",
    "Write your answer": "Skriv svar",
    "Write comment": "Skriv kommentar",
    "Write description": "Skriv beskrivelse",
    "Write here": "Skriv her",
    "Write message": "Skriv besked",
    "Write the code from the marked area below in the text field, to confirm deletion":
        "Skriv koden fra det markerede område ind i tekstfeltet, for at bekræfte sletningen",
    "Write what you hear": "Skriv hvad du hører",
    "Wrong email": "Forkert email",
    "Wrong username/password": "Forkert brugernavn/kodeord",
    "Year/date/title": "År/data/titel",
    Yearly: "Årlig",
    "yearly total": "årligt totalt",
    "Yearly payment": "Årlig betaling",
    Yes: "Ja",
    "Yes, archive this group": "Ja, arkivér dette hold",
    "Yes, delete this assignment": "Ja, slet denne opgave",
    "Yes, delete this collection": "Ja, slet denne kollektion",
    "Yes, delete this feedback": "Ja, slet dette feedback",
    "Yes, delete this file": "Ja, slet denne fil",
    "Yes, delete this folder": "Ja, slet denne mappe",
    "Yes, delete this Geogebra element": "Ja, slet denne Geogebra aktivitet",
    "Yes, delete this group": "Ja, slet dette hold",
    "Yes, delete this group information": "Ja, slet denne information",
    "Yes, delete this post": "Ja, slet dette opslag",
    "Yes, delete this quiz": "Ja, slet denne quiz",
    "Yes, delete this question": "Ja, slet dette spørgsmål",
    "Yes, delete this user": "Ja, slet denne bruger",
    "Yes, do it" : "Ja, gør det",
    "Yes, everyone can use this": "Ja, alle må bruge dette",
    "Yes, turn in this questionnaire": "Ja, aflever dette spørgeskema",
    "Yes, turn in this quiz": "Ja, aflever denne quiz",
    "Yes, remove this course": "Ja, fjern dette forløb",
    "Yes, remove this learning element": "Ja, fjern denne læringsaktivitet",
    "Yes, remove this material": "Ja, fjern denne lektion",
    "Yes, remove this member": "Ja, fjern dette medlem",
    "Yes, start video call": "Ja, start video kald",
    Yesterday: "Igår",
    You: "Du",
    "You have finished this quiz! You got percent correct.":
        "Du har fuldført quizzen! Du fik {insertion} korrekt.",
    "Your assignment plan": "Din afleveringsplan",
    "Your assignment turnin": "Din opgaveaflevering",
    "Your classes": "Dine hold",
    "Your class has multiple sub-groups. Choose which one to view for.":
        "Dit hold har et eller flere underhold. Vælg hvilket et du vil se nedenfor.",
    "Your files have been uploaded and matched.":
        "Dine filer er blevet uploaded og matched med feedback.",
    "Your payment details": "Dine betalingsoplysninger",
    "Your plan": "Din plan",
    "Your streak": "Din streak",
    "Your subscription payment failed.": "Din betaling gik ikke igennem",
    "Your subscription plan": "Dit abonnement",
    Youtube: "Youtube",
    "Youtube search": "Søg YouTube",
    "Youtube video": "Youtube video",
    "YouTube video ID": "YouTube video ID",
    "You answered correct": "Du svarede korrekt",
    "You are currently in exam mode.": "Du er i øjeblikket i {insertion}.",
    "You are currently in exam mode. All communication suspended.":
        "Du er i øjeblikket i eksamenstilstand. Al kommunikation er suspenderet.",
    "You are in a waiting room": "Du er i venteværelset",
    "You are in training mode. Your answers are not recorded, and you get instant feedback. Start the quiz to complete it.":
        "Du er i træningsdelen af quizzen og dine svar bliver ikke gemt. Start quizzen for at gennemføre den.",
    "You are subscribing to": "Du er ved at tilmelde dig",
    "You are up!": "Det er din tur!",
    "You are using Internet Explorer to browse. We do not guarantee support for this, and some areas of the page may not work. We encourage you to switch to any other browser.":
        "Du bruger Internet Explorer til at tilgå vores side. Vi garanterer ikke support for denne browser, og dele af siden kan potentielt ikke virke. Vi anbefaler at skifte til en hvilken som helst anden browser.",
    "You can find the course in your group":
        "Du kan finde forløbet på dit hold",
    "You can find the element on the material":
        "Du kan finde læringsaktiviteten på lektionen",
    "You can find the material on the course":
        "Du kan finde lektionen på forløbet",
    "This can take up to a few minutes, so feel free to grab a cup of coffee or practice your juggling skills while you wait":
        "Dette kan tage op til et par minutter, så tag gerne en kop kaffe eller øv dig på din jonglering, mens du venter.",
    "This assignment requires an attachment. Please attach your file before submitting.": "Denne aflevering kræver en vedhæftning. Vedhæft venligst din fil før du afleverer.",
    "You can not access your assignments here in this group. This will serve as an overview only.":
        "Du kan ikke tilgå dine afleveringer denne vej, på dette hold. Denne app vil kun være et overblik her.",
    "You can not enter the program this way.":
        "Du kan ikke komme ind denne vej.",
    "You can not have a larger question pool than number of questions attached":
        "Du kan ikke have en større spørgsmålspulje end antal spørgsmål tilknyttet",
    "You can't join this call": "Du kan ikke joine dette kald",
    "You can only add admins here": "Du kan kun tilføje undervisere her",
    "You can reject the assignment and force the student to hand in again":
        "Du kan afvise afleveringen og opfordre brugeren til at aflevere igen",
    "You can see this guide to get started":
        "Du kan se denne guide for at komme igang",
    "You did not choose all the correct answers":
        "Du valgte ikke alle de korrekte svar",
    "You do not have much time left for this assignment":
        "Du har ikke meget tid tilbage til denne opgave",
    "You do not have permission to perform this action": "Du har ikke tilladelse til at udføre denne handling",
    "You do not have permission to send notifications for this course": "Du har ikke tilladelse til at sende notifikationer for dette kursus",
    "You do not have permission to send notifications for this lesson": "Du har ikke tilladelse til at sende notifikationer for denne lektion",
    "You have a good amount of time left for this assignment":
        "Du har fint med tid til denne opgave",
    "Hand-ins are closed for this class. Please contact your teacher.":
        "Aflevering er lukket for dette hold. Kontakt din underviser.",
    "The deadline has passed and late hand-in is closed for you on this assignment.":
        "Fristen er overskredet, og aflevering efter frist er lukket for dig på denne opgave.",
    "This assignment is not available to you.":
        "Denne opgave er ikke tilgængelig for dig.",
    "Your hand-in could not be submitted. Please try again, or contact your teacher.":
        "Din aflevering kunne ikke indsendes. Prøv igen, eller kontakt din underviser.",
    "You have already handed this assignment in.":
        "Du har allerede afleveret denne opgave.",
    "You have answered all the questions in this topic. Keep training or go to the next topic.":
        "Du har svaret på alle spørgsmål i dette underemne. Bliv ved med at træne eller gå til næste underemne.",
    "You have assigned duplicate rows to represent the same value":
        "Du har angivet at flere rækker repræsenterer den samme værdi",
    "You have been invited to this class via email":
        "Du er bliver inviteret til dette hold via email",
    "You have created a new course": "Du har oprettet et nyt forløb",
    "You have created a new lesson": "Du har oprettet et nyt lektion",
    "You have missed the due date, or the assignment has been rejected":
        "Du har misset afleveringsdatoen for denne aflevering, eller den er blevet afvist.",
    "You have no messages yet, create your first message to talk to your friends":
        "Du har ingen beskeder endnu, opret din første besked for at tale med dine venner",
    "You have not yet completed the course(s) on which this course depends on":
        "Du har endnu ikke færdiggjort de forløb som dette forløb afhænger af",
    "You have run out of storage": "Du er løbet tør for lagerplads",
    "You have to have atleast one question for your quiz":
        "Du skal have mindst ét spørgsmål tilknyttet til din quiz",
    "You have to have at least one event for your timeline":
        "Du skal have mindst én begivenhed tilknyttet til din tidslinje",
    "You have to have at least one flashcard for your collection":
        "Du skal have mindst ét flashkort tilknyttet til din samling",
    "You have to have at least one question for your questionnaire":
        "Du skal have mindst ét spørgsmål tilknyttet til dit spørgeskema",
    "You must add either a group or a person to the conversation":
        "Du skal enten tilføje mindst et hold eller en person",
    "You must choose minimum one answer": "Du skal vælge minimum ét svar her",
    "You must choose more than one answer":
        "Du skal vælge mere end ét svar her",
    "You must choose only one answer": "Du skal kun vælge ét svar her",
    "You must attach your assignment file to this submission. Do not write your assignment in the text editor below.": "Du skal vedhæfte din opgavefil til denne aflevering. Skriv ikke din opgave i teksteditoren nedenfor.",
    "You must attach your file - do not write in the text editor!": "Du skal vedhæfte din fil - skriv ikke i teksteditoren!",
    "You only need to choose one answer": "Du skal kun vælge ét svar her",
    "You will automatically be added as admin in the group upon creation":
        "Du vil automatisk blive tilføjet som underviser på holdet når du opretter.",
    "You will need a computer for this part to work smoothly!":
        "Du skal bruge en computer, for at denne del kan fungere problemfrit!",
    "Your answer": "Dit svar",
    "Your answer(s)": "Dine svar",
    "Your answer percentage": "Din svarprocent",
    "Your answer was not correct": "Dit svar var ikke korrekt",
    "Your class library is empty, create your first class and start using Learnu":
        "Du har ingen hold på LearnU endnu. Opret dit første hold for at starte med at bruge LearnU",
    "Your groups": "Dine hold",
    "Your level": "Dit niveau",
    "Your nickname": "Dit kaldenavn",
    "Your submission": "Din opgaveaflevering",
    "Your token is not valid or expired. Try again.":
        "Dit  link er ikke godkendt, eller udløbet. Prøv igen.",
    "Want more features and discounts? Request a quote for your entire school or organization today.":
        "Vil du have mere funktionalitet og rabat? Kontakt os idag for en skræddersyet plan til din organisation.",
    "was archived by": "blev arkiveret af",
    "Waiting list": "Venteliste",
    "Waiting for others to arrive": "Venter på at andre ankommer",
    "Watch out": "Pas på",
    "We can not find any course in class. Your teacher should add some courses soon.":
        "Vi kunne ikke finde nogen forløb på holdet {className} endnu. Vent på at din underviser tilføjer forløb." /* Set param like in en_US */,
    "This class isn't open yet": "Holdet er ikke åbnet endnu",
    "Your teacher has not opened anything for the class yet. Check back later.":
        "Din underviser har ikke åbnet noget på holdet endnu. Kig forbi igen senere.",
    "We can not find any *** to display. Wait for your teacher to create ***.":
        "Vi kunne ikke finde nogen {learningElement} på holdet endnu. Vent på at din underviser tilføjer {learningElement}." /* Set param like in en_US */,
    "We could not find matching information to the typed search phrase":
        "Vi kunne ikke finde oplysninger, der svarede til den indtastede søgefrase",
    "What element would you like want to add?":
        "Hvilken aktivitet vil du gerne tilføje?",
    "White labeling": "White labeling",
    widget: "widget",
    "Wiris settings": "Wiris-indstillinger",
    Word: "Ord",
    Words: "Ord",
    "Words list": "Ordliste",
    "Wrong password": "Forkert kodeord",

    "Choose end date": "Vælg slutdato",
    "Choose start date": "Vælg startdato",
    "Create new maternity leave": "Opret ny sygdomsorlov",
    "Maternity-leave": "Sygdomsorlov",
    "Maternity leave": "Sygdomsorlov",
    "Maternity leave registered": "Sygdomsorlov registreret",
    "Period": "Periode",
    "on": "på",
    "Register maternity leave": "Registrér sygdomsorlov",
    "Users on maternity leave": "Brugere på sygdomsorlov",

    "Remove manual submission": "Fjern manuel aflevering",
    "Are you sure you want to delete this manual submission?": "Er du sikker på, at du vil slette denne manuelle aflevering?",
    "This will also delete the associated feedback.": "Dette vil også slette den tilknyttede feedback.",
    "Yes, delete this submission": "Ja, slet denne aflevering",
    "Manual submission removed": "Manuel aflevering fjernet",

    // --- AI-assistent (agent.edaptio.com) ---
    "AI Assistant": "AI-assistent",
    "agent.hide.label": "Skjul Olly indtil du genindlæser siden",
    "agent.hide.permanent_hint": "Skal Olly slås helt fra, gør du det under din profil",
    "Show the Olly assistant on my screen": "Vis Olly-assistenten på min skærm",
    "transcription.user_setting.title": "Optagelser i rettemodulet",
    "Write out what I say in my recordings": "Skriv ud hvad jeg siger i mine optagelser",
    "transcription.user_setting.hint": "Når den er slået fra, får dine tale- og skærmoptagelser ingen tekst under sig — kursisten skal se eller høre optagelsen. Det gælder alle de optagelser, du selv laver. En underviser kan også slå det fra for et helt hold.",
    "transcription.group_setting.title": "Optagelser i rettemodulet",
    "transcription.group_setting.description": "Bestem om tale- og skærmoptagelser på dette hold skal skrives ud som tekst. Når den er slået fra, står der ingen tekst under optagelsen — hverken i kommentarfeltet eller i den rettede PDF. Det gælder alle undervisere på holdet.",
    "Write out speech in recordings": "Skriv tale ud som tekst",
    "olly.user_setting.hint": "Slår du den fra, forsvinder Olly overalt i Edaptio for dig. Din skole eller underviseren på et hold kan også slå Olly fra — det kan du ikke selv lave om på.",
    "Show small confirmations in the corner of the screen": "Vis små bekræftelser i hjørnet af skærmen",
    "ui_toasts.user_setting.hint": "Det er de små grønne bokse nede i venstre hjørne, fx \"Dato gemt\". Fejlbeskeder bliver vist under alle omstændigheder.",
    "olly.group_setting.description": "Bestem om Olly må bruges på dette hold. Slår du den fra for kursisterne, kan de ikke bruge Olly til noget på holdet — heller ikke fra deres egen skærm. De to indstillinger er uafhængige af hinanden.",
    "Allow Olly for students": "Tillad Olly for kursister",
    "Allow Olly for teachers": "Tillad Olly for undervisere",
    "annotator.mismatch.embedpdf_committed": "Denne aflevering er rettet i EmbedPDF. Rettelserne vises ikke i Kami.",
    "annotator.mismatch.kami_committed": "Denne aflevering er rettet i Kami. Rettelserne vises ikke i EmbedPDF.",
    "Connecting...": "Forbinder...",
    "Minimize": "Minimer",
    "Ask the assistant anything about your classes, assignments, or content.": "Spørg assistenten om dine klasser, afleveringer eller indhold.",
    "Thinking...": "Tænker...",
    "Ask the assistant...": "Spørg assistenten...",
    "Send": "Send",
    "New conversation": "Ny samtale",
    "Conversations": "Samtaler",
    "No previous conversations": "Ingen tidligere samtaler",
    "Untitled chat": "Uden titel",
    "Archive": "Arkiver",
    "Delete this conversation?": "Slet denne samtale?",
    "Loading conversation...": "Indlæser samtale...",

    // --- AI Agent empty-state suggestion chips ---
    // Student prompts are shaped by teacher feedback (Naida Elmer, Frederiksberg
    // VUC/STX): kursister glemmer at læse nyheder, huske frister og læse feedback.
    "agent.suggestion.student.1": "Hvad mangler jeg at aflevere?",
    "agent.suggestion.student.2": "Er der nyheder på mit hold?",
    "agent.suggestion.student.3": "Hvordan går det mig i mine fag?",
    "agent.suggestion.student.4": "Forklar mig den næste opgave",
    "agent.suggestion.teacher.1": "Hvordan går det i min klasse?",
    "agent.suggestion.teacher.2": "Hvilke elever er bagud?",
    "agent.suggestion.teacher.3": "Lav en quiz om emnet i denne lektion",
    "agent.suggestion.teacher.4": "Skriv en nyhed til klassen",

    // Teaser bubble next to the closed Olly icon (students only)
    "Dismiss": "Afvis",
    "agent.teaser.generic": "Få hjælp af Olly",
    "agent.teaser.assignment": "Få hjælp til denne opgave",
    "agent.teaser.assignment.prompt": "Kan du forklare mig denne opgave og hjælpe mig i gang?",
    "Reconnecting...": "Forbinder igen...",
    "Connection lost. Reload the page to try again.": "Forbindelsen blev afbrudt. Genindlæs siden for at prøve igen.",
    "agent.header.subtitle": "Spørg mig om hvad som helst",
    "agent.empty.greeting.named": "Hej {name} 👋",
    "agent.empty.greeting.generic": "Hej 👋",

    // --- AI Agent tool labels ---
    "tool.find_upcoming_assignments.running": "Finder kommende afleveringer…",
    "tool.find_upcoming_assignments.done": "Kommende afleveringer hentet",
    "tool.lookup_assignment.running": "Slår afleveringen op…",
    "tool.lookup_assignment.done": "Afleveringen hentet",
    "tool.lookup_my_handin.running": "Henter din besvarelse…",
    "tool.lookup_my_handin.done": "Besvarelsen hentet",
    "tool.lookup_learning_element.running": "Henter læringselement…",
    "tool.lookup_learning_element.done": "Læringselement hentet",
    "tool.list_my_classes.running": "Henter dine klasser…",
    "tool.list_my_classes.done": "Klasserne hentet",
    "tool.lookup_group.running": "Henter klassen…",
    "tool.lookup_group.done": "Klassen hentet",
    "tool.list_members.running": "Henter medlemmer…",
    "tool.list_members.done": "Medlemmerne hentet",
    "tool.list_group_information.running": "Henter klasseinformation…",
    "tool.list_group_information.done": "Klasseinformation hentet",
    "tool.list_news.running": "Henter nyheder…",
    "tool.list_news.done": "Nyhederne hentet",
    "tool.get_my_progress.running": "Henter dine fremskridt…",
    "tool.get_my_progress.done": "Fremskridt hentet",
    "tool.list_missing_feedback.running": "Tjekker manglende feedback…",
    "tool.list_missing_feedback.done": "Manglende feedback hentet",
    "tool.list_notifications.running": "Henter notifikationer…",
    "tool.list_notifications.done": "Notifikationer hentet",
    "tool.create_assignment.running": "Opretter afleveringen…",
    "tool.create_assignment.done": "Afleveringen oprettet",
    "tool.update_assignment.running": "Opdaterer afleveringen…",
    "tool.update_assignment.done": "Afleveringen opdateret",
    "tool.create_quiz.running": "Opretter quizzen…",
    "tool.create_quiz.done": "Quizzen oprettet",
    "tool.create_quiz_question.running": "Tilføjer spørgsmål…",
    "tool.create_quiz_question.done": "Spørgsmål tilføjet",
    "tool.create_flashcard_deck.running": "Opretter flashcard-sæt…",
    "tool.create_flashcard_deck.done": "Flashcard-sæt oprettet",
    "tool.create_flashcard.running": "Opretter flashcard…",
    "tool.create_flashcard.done": "Flashcard oprettet",
    "tool.create_text_element.running": "Opretter tekstelement…",
    "tool.create_text_element.done": "Tekstelement oprettet",
    "tool.create_lesson.running": "Opretter lektionen…",
    "tool.create_lesson.done": "Lektionen oprettet",
    "tool.create_course.running": "Opretter forløbet…",
    "tool.create_course.done": "Forløbet oprettet",
    "tool.create_news.running": "Opretter nyhed…",
    "tool.create_news.done": "Nyheden oprettet",
    "tool.create_group_information.running": "Opretter klasseinformation…",
    "tool.create_group_information.done": "Klasseinformation oprettet",
    "tool.attach_element_to_lesson.running": "Tilføjer til lektion…",
    "tool.attach_element_to_lesson.done": "Tilføjet til lektionen",
    "tool.move_learning_element.running": "Flytter elementerne…",
    "tool.move_learning_element.done": "Elementerne flyttet",
    "tool.hide_learning_element.running": "Ændrer synlighed…",
    "tool.hide_learning_element.done": "Synligheden ændret",
    "tool.move_lesson.running": "Flytter lektionen…",
    "tool.move_lesson.done": "Lektionen flyttet",
    "tool.reorder_courses.running": "Sorterer forløbene…",
    "tool.reorder_courses.done": "Forløbene sorteret",
    "tool.update_course.running": "Opdaterer forløbet…",
    "tool.update_course.done": "Forløbet opdateret",
    "tool.update_lesson.running": "Opdaterer lektionen…",
    "tool.update_lesson.done": "Lektionen opdateret",
    "tool.lookup_lesson.running": "Henter lektionen…",
    "tool.lookup_lesson.done": "Lektionen hentet",
    "tool.lookup_quiz.running": "Henter quizzen…",
    "tool.lookup_quiz.done": "Quizzen hentet",
    "tool.update_quiz.running": "Opdaterer quizzen…",
    "tool.update_quiz.done": "Quizzen opdateret",
    "tool.update_quiz_question.running": "Opdaterer spørgsmål…",
    "tool.update_quiz_question.done": "Spørgsmål opdateret",
    "tool.delete_quiz_question.running": "Sletter spørgsmål…",
    "tool.delete_quiz_question.done": "Spørgsmål slettet",
    "tool.delete_learning_element.running": "Fjerner elementet…",
    "tool.delete_learning_element.done": "Elementet fjernet",
    "tool.grade_handin.running": "Giver feedback…",
    "tool.grade_handin.done": "Feedback givet",
    "tool.release_feedback.running": "Frigiver feedback…",
    "tool.release_feedback.done": "Feedback frigivet",
    "tool.class_overview.running": "Laver klasseoversigt…",
    "tool.class_overview.done": "Klasseoversigt hentet",
    "tool.list_students_behind.running": "Tjekker elever bagud…",
    "tool.list_students_behind.done": "Elever bagud hentet",
    "tool.send_message.running": "Sender besked…",
    "tool.send_message.done": "Besked sendt",
    "tool.create_timeline.running": "Opretter tidslinje…",
    "tool.create_timeline.done": "Tidslinje oprettet",
    "tool.lookup_timeline.running": "Henter tidslinjen…",
    "tool.lookup_timeline.done": "Tidslinjen hentet",
    "tool.update_timeline.running": "Opdaterer tidslinjen…",
    "tool.update_timeline.done": "Tidslinjen opdateret",
    "tool.update_text_element.running": "Opdaterer tekstelement…",
    "tool.update_text_element.done": "Tekstelement opdateret",
    "tool.create_external_link.running": "Opretter link…",
    "tool.create_external_link.done": "Linket oprettet",
    "tool.update_external_link.running": "Opdaterer link…",
    "tool.update_external_link.done": "Linket opdateret",
    "tool.create_media_embed.running": "Indlejrer video…",
    "tool.create_media_embed.done": "Videoen indlejret",
    "tool.update_media.running": "Opdaterer medie…",
    "tool.update_media.done": "Mediet opdateret",
    "tool.create_questionnaire.running": "Opretter spørgeskema…",
    "tool.create_questionnaire.done": "Spørgeskema oprettet",
    "tool.lookup_questionnaire.running": "Henter spørgeskemaet…",
    "tool.lookup_questionnaire.done": "Spørgeskemaet hentet",
    "tool.update_questionnaire.running": "Opdaterer spørgeskemaet…",
    "tool.update_questionnaire.done": "Spørgeskemaet opdateret",
    "tool.lookup_flashcard_deck.running": "Henter flashcard-sættet…",
    "tool.lookup_flashcard_deck.done": "Flashcard-sættet hentet",
    "tool.update_flashcard_deck.running": "Opdaterer flashcard-sættet…",
    "tool.update_flashcard_deck.done": "Flashcard-sættet opdateret",
    "tool.create_board.running": "Opretter tavle…",
    "tool.create_board.done": "Tavlen oprettet",
    "tool.add_board_note.running": "Tilføjer note…",
    "tool.add_board_note.done": "Noten tilføjet",
    "tool.update_board.running": "Opdaterer tavlen…",
    "tool.update_board.done": "Tavlen opdateret",
    // EmbedPDF rich annotations (Kami replacement V1, 2026-05-06)
    Annotations: "Annotationer",
    "Could not start recording": "Kunne ikke starte optagelsen",
    "The recording came out empty. Please try again.": "Optagelsen blev tom. Prøv igen.",
    Equation: "Ligning",
    "Microphone is not available in this browser":
        "Mikrofonen er ikke tilgængelig i denne browser",
    "No rich annotations yet": "Ingen rige annotationer endnu",
    "Re-record": "Optag igen",
    "Read aloud": "Læs op",
    Record: "Optag",
    "Rich comment": "Rig kommentar",
    "Save annotation": "Gem annotation",
    "Stop failed": "Stop mislykkedes",
    Stop: "Stop",
    "Transcribing…": "Transskriberer…",
    "Uploading…": "Uploader…",
    "Voice note": "Stemmenotat",
    "This mark already has a recording": "Denne markering har allerede en optagelse",
    "Video comment": "Videokommentar",
    "Screen recording": "Skærmoptagelse",
    "Watch video comment": "Se videokommentar",
    "Watch screen recording": "Se skærmoptagelse",
    "Click on the PDF to place the video comment": "Klik på PDF'en for at placere videokommentaren",
    "Click on the PDF to place the screen recording": "Klik på PDF'en for at placere skærmoptagelsen",
    "Formula": "Formel",
    "Place formula": "Indsæt formel",
    "Update formula": "Opdater formel",
    "Insert formula": "Indsæt formel i kommentaren",
    "Click on the PDF to place the formula": "Klik på PDF'en for at placere formlen",
    "The formula could not be rendered. Check it and try again.": "Formlen kunne ikke gengives. Tjek den, og prøv igen.",
    "Structure": "Opbygning",
    "Relations": "Relationer",
    "Operators": "Regnetegn",
    "Greek letters": "Græske bogstaver",
    "Functions": "Funktioner",
    "Fraction": "Brøk",
    "Square root": "Kvadratrod",
    "Nth root": "N'te rod",
    "Power": "Potens",
    "Subscript": "Sænket skrift",
    "Parentheses": "Parenteser",
    "Absolute value": "Numerisk værdi",
    "Less than or equal to": "Mindre end eller lig med",
    "Greater than or equal to": "Større end eller lig med",
    "Not equal to": "Forskellig fra",
    "Approximately equal to": "Tilnærmelsesvis lig med",
    "Plus-minus": "Plus-minus",
    "Implies": "Medfører",
    "Multiplication dot": "Gangetegn (prik)",
    "Times": "Gange",
    "Divided by": "Divideret med",
    "Sum": "Sum",
    "Integral": "Integral",
    "Limit": "Grænseværdi",
    "Infinity": "Uendelig",
    "Pi": "Pi",
    "Alpha": "Alfa",
    "Beta": "Beta",
    "Theta": "Theta",
    "Delta": "Delta",
    "Degree": "Grader",
    "Sine": "Sinus",
    "Cosine": "Cosinus",
    "Tangent": "Tangens",
    "Logarithm": "Logaritme",
    "Natural logarithm": "Naturlig logaritme",
    "Open the comments panel to see your recordings": "Åbn kommentarpanelet for at se dine optagelser",
    "Recordings": "Optagelser",
    "Go to page": "Gå til side",
    "Camera": "Kamera",
    "Recording": "Optager",
    "Screen recording is not available in this browser. On iPad, record a video comment instead.": "Skærmoptagelse er ikke tilgængelig i denne browser. På iPad kan du optage en videokommentar i stedet.",
    "This browser records in a format some phones cannot play. Chrome or Safari gives the best result.": "Denne browser optager i et format, som nogle telefoner ikke kan afspille. Chrome eller Safari giver det bedste resultat.",
    "Share only the window or tab you want to record — avoid sharing your whole screen.": "Del kun det vindue eller den fane, du vil optage — undgå at dele hele skærmen.",
    "Uploaded": "Uploadet",
    "Start recording": "Start optagelse",
    Eraser: "Viskelæder",
    "Comment on selection": "Kommentér markering",
    "Add comment": "Tilføj kommentar…",
    "Comments in the margin": "Kommentarer i margen",
    "Comments in the margin: on": "Kommentarer i margen: til",
    "Comments in the margin: off": "Kommentarer i margen: fra",

    // Upload modal (EdaptioUploadModal + sources)
    "Upload files": "Upload filer",
    "Upload source": "Upload-kilde",
    "My Device": "Min enhed",
    "OneDrive": "OneDrive",
    "Google Drive": "Google Drive",
    PDF: "PDF",
    "Select files to upload": "Vælg filer der skal uploades",
    "or drag and drop here": "eller træk og slip her",
    "Record audio": "Optag lyd",
    "Record Audio": "Optag lyd",
    "Record video": "Optag video",
    "Record Video": "Optag video",
    "Take Photo": "Tag foto",
    Retake: "Tag igen",
    Adding: "Tilføjer…",
    "Connect OneDrive": "Forbind OneDrive",
    "Connect Google Drive": "Forbind Google Drive",
    "Open OneDrive": "Åbn OneDrive",
    "Open Google Drive": "Åbn Google Drive",
    "Pick from OneDrive": "Vælg fra OneDrive",
    "Pick from OneDrive for Business": "Vælg fra OneDrive for Business",
    "Pick from Google Drive": "Vælg fra Google Drive",
    "Connect": "Forbind",
    "Connect OneDrive for Business": "Forbind OneDrive for Business",
    "Sign in with your school or work Microsoft account to pick files from OneDrive for Business.":
        "Log ind med din skole- eller arbejds-Microsoft-konto for at vælge filer fra OneDrive for Business.",
    "Connected as": "Forbundet som",
    "Switch account": "Skift konto",
    "Pick files from your OneDrive Personal or OneDrive for Business account.":
        "Vælg filer fra din OneDrive Personal- eller OneDrive for Business-konto.",
    "Sign in with Google to pick files straight from your Drive.":
        "Log ind med Google for at vælge filer direkte fra dit Drev.",
    "Click record to capture audio with your microphone.":
        "Klik på Optag for at optage lyd med din mikrofon.",
    "Preview your recording": "Forhåndsvis din optagelse",
    "Preview your photo": "Forhåndsvis dit foto",
    "Camera is not available in this browser": "Kameraet er ikke tilgængeligt i denne browser",
    "Camera permission denied": "Adgang til kameraet blev afvist",
    "Could not open OneDrive": "Kunne ikke åbne OneDrive",
    "Could not open Google Drive": "Kunne ikke åbne Google Drive",
    "Could not fetch URL": "Kunne ikke hente URL'en",
    "OneDrive is not configured for this environment.":
        "OneDrive er ikke konfigureret i dette miljø.",
    "Google Drive is not configured for this environment.":
        "Google Drive er ikke konfigureret i dette miljø.",
    "Your organisation has not approved Edaptio for OneDrive access yet.":
        "Din organisation har endnu ikke godkendt Edaptio til OneDrive-adgang.",
    "Ask your IT admin to approve Edaptio in Azure AD.":
        "Bed din IT-administrator om at godkende Edaptio i Azure AD.",
    "OneDrive did not return an access token.":
        "OneDrive returnerede ikke et adgangstoken.",
    "Your school creates your Edaptio account for you":
        "Din skole opretter din Edaptio-konto for dig. Vent til den er klar, eller kontakt din skole, hvis du ikke kan logge ind.",
    "This Microsoft account belongs to your school and can only be connected to your school account":
        "Denne Microsoft-konto tilhører din skole og kan kun forbindes til din skolekonto. Log ind på din skolekonto og prøv igen.",
    "Captured photo": "Optaget foto",
    "Capture failed": "Optagelse mislykkedes",
    "Importing files": "Importerer filer",
    Fetching: "Henter",
    Cancelled: "Annulleret",
    "Import from a URL": "Importér fra en URL",
    "Paste a public link and we will fetch the file straight into your Edaptio uploads.":
        "Indsæt et offentligt link, så henter vi filen direkte ind i dine Edaptio-uploads.",
    done: "færdig",
    failed: "mislykkedes",
    "Click on the PDF to place the voice note":
        "Klik på PDF'en for at placere stemmenotatet",
    "Open the comments panel to see voice notes":
        "Åbn kommentarpanelet for at se stemmenotaterne",
    Microphone: "Mikrofon",
    "Microphone permission denied": "Adgang til mikrofon nægtet",
    "No microphone detected": "Ingen mikrofon fundet",
    "Default microphone": "Standardmikrofon",
    "We can hear you": "Vi kan høre dig",
    "Speak to test your microphone": "Sig noget for at teste din mikrofon",
    "Allow microphone access to record": "Tillad mikrofonadgang for at optage",
    "Could not export annotated PDF": "Kunne ikke eksportere den annoterede PDF",
    "Could not attach the corrections to the feedback": "Rettelserne kunne ikke vedhæftes feedbacken",
    "Could not open the document": "Dokumentet kunne ikke åbnes",
    "Could not download the document": "Dokumentet kunne ikke hentes",
    "Some annotations could not be saved. Please check your connection and try again.":
        "Nogle annoteringer kunne ikke gemmes. Tjek din internetforbindelse og prøv igen.",
    "You have unsaved annotation changes. Close anyway?":
        "Du har annoteringsændringer, der ikke er gemt. Vil du lukke alligevel?",
    "Close anyway": "Luk alligevel",
    "(continued)": "(fortsat)",
    "Listen to voice note": "Lyt til stemmenotat",
    "Select text in the PDF first": "Markér først tekst i PDF'en",
    "Maximum recording length reached": "Maksimal optagelængde nået",
    "Stop": "Stop",
    "External login failed. Please try again.": "Eksternt login mislykkedes. Prøv igen.",
    "Download as PDF": "Download som PDF",
    "Preparing…": "Forbereder…",
    "Could not open the document for editing":
        "Kunne ikke åbne dokumentet til redigering",
    "Add channel": "Add channel",
    "Add conversation title": "Add conversation title",
    "Add course widget": "Add course widget",
    "Add question title": "Tilføj spørgsmålstitel",
    "Admin login": "Admin login",
    "Annotator": "Annotator",
    "Answer the question to continue watching the video":
        "Answer the question to continue watching the video",
    "Archive for all members": "Archive for all members",
    "Archive group": "Archive group",
    "Are you sure you want to archive this group?": "Are you sure you want to archive this group?",
    "Category title": "Category title",
    "Channels": "Channels",
    "Connect OneDrive Personal": "Forbind OneDrive Personal",
    "Consultation": "Consultation",
    "Copy group contents": "Copy group contents",
    "Corporation": "Corporation",
    "Course not found": "Course not found",
    "Create account": "Create account",
    "Destination group id": "Destination group id",
    "Exam mode limits the students communication features for an entire team during an exam. Can be turned on/off at any time, and works right away.":
        "Exam mode limits the students communication features for an entire team during an exam. Can be turned on/off at any time, and works right away.",
    "Failed to copy class": "Failed to copy class",
    "Failed to highlight board item": "Failed to highlight board item",
    "Feedback received": "Feedback received",
    "Group deleted": "Group deleted",
    "Here you can copy all your group contents to another group. Remember that elements you have previously copied will only be synchronized, and not copied again.":
        "Here you can copy all your group contents to another group. Remember that elements you have previously copied will only be synchronized, and not copied again.",
    "Hey": "Hey",
    "Highlighted": "Highlighted",
    "If you have downloaded your assignments via the \"download as zip\" button, then you can upload the feedback files directly here. We will automatically generate feedback and attach the files. Make sure you only upload files you have not uploaded before, and only for submissions you have not given feedback to already.":
        "If you have downloaded your assignments via the \"download as zip\" button, then you can upload the feedback files directly here. We will automatically generate feedback and attach the files. Make sure you only upload files you have not uploaded before, and only for submissions you have not given feedback to already.",
    "Image label": "Image label",
    "Institution name": "Institutionsnavn",
    "Active users": "Aktive brugere",
    "Institution Payments": "Institution Payments",
    "Institution created": "Institution created",
    "Join now": "Join now",
    "Manage institutions": "Manage institutions",
    "Network error - please try again": "Network error - please try again",
    "No content found": "No content found",
    "No results found": "No results found",
    "OneDrive Personal needs the legacy OneDrive API permission on the Azure app registration. Add the OneDrive API (app id 6a9b9266-…) with the OneDrive.ReadWrite delegated permission and grant admin consent.":
        "OneDrive Personal kræver den ældre OneDrive API-tilladelse på Azure-app-registreringen. Tilføj OneDrive API (app-id 6a9b9266-…) med den delegerede tilladelse OneDrive.ReadWrite, og giv administratorsamtykke.",
    "Only open answers for now": "Only open answers for now",
    "Or continue using your phone or tablet with limited functionality.":
        "Or continue using your phone or tablet with limited functionality.",
    "Pick from OneDrive Personal": "Vælg fra OneDrive Personal",
    "Picture saved": "Picture saved",
    "Play the video and answer the questions along the way":
        "Play the video and answer the questions along the way",
    "Popup blocked — allow popups for this site.": "Pop op-vindue blokeret — tillad pop op-vinduer for dette websted.",
    "Provide general feedback about the question": "Giv generel feedback til spørgsmålet",
    "Register student's submission": "Register student's submission",
    "Repeat new email": "Repeat new email",
    "STEM": "STEM",
    "Save audio": "Save audio",
    "Save board": "Save board",
    "Sign in with your personal Microsoft account (@outlook.com, @hotmail.com, @live.com).":
        "Log ind med din personlige Microsoft-konto (@outlook.com, @hotmail.com, @live.com).",
    "Sorry to see you go": "Sorry to see you go",
    "Source group id": "Source group id",
    "Speakers": "Speakers",
    "Student name": "Student name",
    "Subject category": "Subject category",
    "Text label": "Text label",
    "This Microsoft account does not have OneDrive for Business. Ask your IT admin to enable SharePoint Online for the tenant.":
        "Denne Microsoft-konto har ikke OneDrive for Business. Bed din IT-administrator om at aktivere SharePoint Online for organisationen.",
    "This course has been copied to this group before.": "This course has been copied to this group before.",
    "This is a personal Microsoft account. Use the \"OneDrive Personal\" tab instead.":
        "Dette er en personlig Microsoft-konto. Brug fanen \"OneDrive Personal\" i stedet.",
    "This is an overview of the students progression through the videos in the courses/materials.":
        "This is an overview of the students progression through the videos in the courses/materials.",
    "This lesson has been copied to this group before.": "This lesson has been copied to this group before.",
    "Unarchive class": "Unarchive class",
    "Unilogin": "Unilogin",
    "Unmuted": "Unmuted",
    "Upload file": "Upload file",
    "Upload image": "Upload image",
    "Use lessons to divide your courses into smaller bites, that are easier for users to digest. Lessons are packages of learning elements that provide context to the learning the user has to obtain.":
        "Use lessons to divide your courses into smaller bites, that are easier for users to digest. Lessons are packages of learning elements that provide context to the learning the user has to obtain.",
    "We can not find any consultations to display. Wait for your teacher to create some.":
        "We can not find any consultations to display. Wait for your teacher to create some.",
    "Wiris match": "Wiris match",
    "Wiris multiple choice": "Wiris multiple choice",
    "Wiris short answer": "Wiris short answer",
    "completed": "completed",
    "document": "document",
    "file": "file",
    "Could not send an invitation to: {emails}": "Invitationen kunne ikke sendes til: {emails}",
    "Could not send the invitations. Please try again.": "Invitationerne kunne ikke sendes. Prøv igen.",
    "Email sender name": "Afsendernavn på mails",
    "Shown as the sender of emails. Leave empty to use Edaptio.": "Vises som afsender af mails. Lad feltet stå tomt for at bruge Edaptio.",
    "Sender name": "Afsendernavn",
    "Email reply-to address": "Svar-til adresse på mails",
    "Replies to emails are sent here. Leave empty to use Edaptio.": "Svar på mails sendes hertil. Lad feltet stå tomt for at bruge Edaptio.",
    "Download summary": "Download opsummering",
    "Download all answers": "Download alle besvarelser",
    "Question number": "Spørgsmålsnr.",
    "Question text": "Spørgsmålstekst",
    "Number of answers": "Antal svar",
    "Share of answers": "Andel af svar",
    "Response": "Besvarelse",
    "Started": "Startet",
    "Summary": "Opsummering",
    "All answers": "Alle besvarelser",
    "Evaluations": "Evalueringer",
    "Evaluation": "Evaluering",
    "Evaluation ID": "Evaluerings-id",
    "Sheet": "Ark",
    "Responses": "Besvarelser",
    "Every evaluation on the school's classes. Select the ones you need and download them as one Excel file, each evaluation on its own sheet.": "Alle evalueringer på skolens hold. Vælg dem, du skal bruge, og hent dem som én Excel-fil med hver evaluering på sit eget ark.",
    "Search by title or class": "Søg på titel eller hold",
    "Only evaluations with answers": "Kun evalueringer med besvarelser",
    "Download {count} evaluations as Excel": "Hent {count} evalueringer som Excel",
    "Fetching answers… {done} of {total}": "Henter besvarelser… {done} af {total}",
    "No evaluations found": "Ingen evalueringer fundet",
    "Could not load the evaluations. Please try again.": "Evalueringerne kunne ikke indlæses. Prøv igen.",
    "Could not download the evaluations. Please try again.": "Evalueringerne kunne ikke hentes. Prøv igen.",
  "Remove unenrolled students from classes": "Fjern udmeldte kursister fra hold",
  "Students UMS/Ludus no longer has on a class are moved to dropped-out students on every sync.": "Kursister, som UMS/Ludus ikke længere har på et hold, flyttes til udmeldte kursister ved hver synkronisering.",
  "Synchronise with UMS/Ludus": "Synkronisér med UMS/Ludus",
  "Runs the same synchronisation as the nightly one: new and moved students are enrolled, and — if the switch above is on — unenrolled students are moved to dropped-out students.": "Kører den samme synkronisering som den natlige: nye og flyttede kursister tilmeldes, og — hvis kontakten ovenfor er slået til — flyttes udmeldte kursister til udmeldte kursister.",
  "Last synchronisation": "Seneste synkronisering",
  "Last manual synchronisation": "Seneste manuelle synkronisering",
  "{count} students moved to dropped-out students": "{count} kursister flyttet til udmeldte kursister",
  "A synchronisation starts within five minutes and takes up to 15. It runs in the background — you can leave this page.": "En synkronisering starter inden for fem minutter og tager op til 15. Den kører i baggrunden — du kan godt forlade siden.",
  "Synchronise now": "Synkronisér nu",
  "Synchronising...": "Synkroniserer...",
  "Synchronisation queued": "Synkronisering sat i kø",
  "A synchronisation is already queued or running": "En synkronisering er allerede sat i kø eller i gang",
  "Could not start the synchronisation right now. Try again shortly.": "Synkroniseringen kunne ikke startes lige nu. Prøv igen om lidt.",
  "Queued": "I kø",
  "Running": "I gang",
  "Completed": "Gennemført",
  "Failed": "Mislykkedes",
  "Dropped out earlier and added back": "Udmeldt tidligere og tilføjet igen",
  "This class is filled automatically from several holds, so it cannot be compared with one hold in UMS/Ludus.": "Dette hold fyldes automatisk fra flere hold, så det kan ikke sammenlignes med ét hold i UMS/Ludus.",
  "Select messages": "Vælg beskeder",
  "Select conversations": "Vælg samtaler",
  "Cancel selection": "Annullér valg",
  "{count} selected": "{count} valgt",
  "Select all": "Vælg alle",
  "Deselect all": "Fravælg alle",
  // Split hold: students assigned to one of the hold's teachers
  "No students match your filters.": "Ingen elever matcher dine filtre.",
  "All students": "Alle elever",
  "Not assigned": "Ikke tildelt",
  "No teacher": "Ingen lærer",
  "Assign selected to": "Tildel valgte til",
  "Students assigned": "Eleverne er tildelt",
  "Only my students": "Kun mine elever",
  "{n} selected": "{n} valgt",
  "You can only delete messages you have sent yourself": "Du kan kun slette beskeder, du selv har sendt",
  "Do you want to delete {count} messages for all members?": "Vil du slette {count} beskeder for alle deltagere?",
  "{count} messages could not be deleted": "{count} beskeder kunne ikke slettes",
  "The messages were succesfully deleted": "Beskederne blev slettet",
  "Do you want to delete {count} conversations? They will only be removed for you.": "Vil du slette {count} samtaler? De fjernes kun for dig.",
  "{count} conversations could not be deleted": "{count} samtaler kunne ikke slettes",
  "The conversations were succesfully deleted": "Samtalerne blev slettet",
  "Do you want to archive {count} conversations?": "Vil du arkivere {count} samtaler?",
  "{count} conversations could not be archived": "{count} samtaler kunne ikke arkiveres",
  "Do you want to delete {count} selected files and folders?": "Vil du slette {count} valgte filer og mapper?",
  "{count} files could not be deleted": "{count} filer kunne ikke slettes",
  "The files were deleted": "Filerne blev slettet",
  "Notes": "Noter",
  "Write a note": "Skriv en note",
  "Add note": "Tilføj note",
  "No notes yet": "Ingen noter endnu",
  "General note": "Generel note",
  "Imported": "Importeret",
  "edited": "redigeret",
  "Delete this note?": "Vil du slette denne note?",
  "See all notes": "Se alle noter",
  "Notes about students": "Noter om kursister",
  "This file type cannot be uploaded. Save it as PDF or Word and try again.": "Denne filtype kan ikke uploades. Gem den som PDF eller Word, og prøv igen.",
  "The upload lost its connection. Check your internet connection and try again.": "Uploaden mistede forbindelsen. Tjek din internetforbindelse, og prøv igen.",
  "This question could not be checked with its numbers, so it has new ones. Please answer it again.": "Spørgsmålet kunne ikke rettes med de tal, det havde, så det har fået nye. Svar på det igen.",
  "Your answer could not be checked right now. Please try again in a moment.": "Dit svar kunne ikke rettes lige nu. Prøv igen om et øjeblik.",
  "Your answer could not be saved. Please try again.": "Dit svar kunne ikke gemmes. Prøv igen.",
  "Use notes about students": "Brug noter om kursister",
  "Teachers and administrators can keep notes about students, per class or general.": "Lærere og administratorer kan skrive noter om kursister, på et hold eller generelt.",
  "Students can see notes about themselves": "Kursister kan se noter om sig selv",
  "Students see the notes about themselves, read-only, on the class member list.": "Kursisten ser noterne om sig selv på holdets medlemsliste og kan ikke ændre dem.",
  "Teachers can see general notes": "Lærere kan se generelle noter",
  "Teachers see the general notes administrators write about the students they teach.": "Lærere ser de generelle noter, som administrationen skriver om kursister på deres hold.",
  "Teachers can see other classes' notes": "Lærere kan se noter fra andre hold",
  "Teachers see notes from the student's other classes, not just their own classes.": "Lærere ser også noter fra kursistens andre hold, ikke kun fra deres egne hold.",
  "The student can also see this note.": "Kursisten kan også se denne note.",
  "Only teachers and administrators can see this note.": "Kun lærere og administratorer kan se denne note.",
  "The copy is taking longer than expected. It may still finish, so check the class in a few minutes before you copy again.": "Kopieringen tager længere tid end forventet. Den kan stadig blive færdig, så tjek holdet om et par minutter, før du kopierer igen.",
  "The copy failed. Please try again.": "Kopieringen mislykkedes. Prøv igen.",
  "A download of the submissions is already in progress. Wait for it to finish.": "Afleveringerne er allerede ved at blive downloadet. Vent, til den download er færdig.",
  "Read-only access": "Læseadgang",
  "People with read-only access see the hold's courses, lessons, assignments, files and news, as a student would. They cannot hand in, write or comment, and they do not see the members or anyone's work.": "Personer med læseadgang kan se holdets forløb, lektioner, opgaver, filer og nyheder, som en kursist ser dem. De kan ikke aflevere, skrive eller kommentere, og de kan ikke se medlemmerne eller andres besvarelser.",
  "Access until (optional)": "Adgang til og med (valgfrit)",
  "Give read-only access": "Giv læseadgang",
  "Nobody has read-only access to this hold.": "Ingen har læseadgang til dette hold.",
  "Access ended {date}": "Adgangen udløb {date}",
  "Access until {date}": "Adgang til og med {date}",
  "No end date": "Ingen slutdato",
  "Remove read-only access": "Fjern læseadgang",
  "Read-only access given": "Læseadgang givet",
  "No Edaptio account has that email. Create the user first.": "Der findes ingen Edaptio-bruger med den e-mail. Opret brugeren først.",
  "That person is already a member of the hold.": "Personen er allerede medlem af holdet.",
  "Read-only access removed": "Læseadgang fjernet",
  "You have read-only access to this hold. You can look at everything, but not hand in, write or comment.": "Du har læseadgang til dette hold. Du kan se alt, men ikke aflevere, skrive eller kommentere.",
  "View quiz": "Se quizzen",
  "You have read-only access: you can see the questions, but not answer them.": "Du har læseadgang: du kan se spørgsmålene, men ikke besvare dem.",
  "Holds with read-only access": "Hold med læseadgang",
  "You no longer have access to this conversation": "Du har ikke længere adgang til denne samtale",
};
